import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db, storage } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { Document, Page, Text, View, StyleSheet, pdf } from "@react-pdf/renderer";
import numberToWords from "number-to-words";
import { onAuthStateChanged } from 'firebase/auth';
import {
    Grid, Card, CardContent, Typography, Button, Stack, Avatar, Divider, Box, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Paper, Chip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
    FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput,
    Select, TextField
} from "@mui/material";


import Close from "@mui/icons-material/Close";
import SwapHoriz from "@mui/icons-material/SwapHoriz";
import Edit from "@mui/icons-material/Edit";
import Add from "@mui/icons-material/Add";
import Delete from "@mui/icons-material/Delete";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import { useNavigate } from "react-router-dom";

function Reservationdetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const navigate = useNavigate();

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
    const [serviceModalOpen, setServiceModalOpen] = useState(false);
    const [custModalOpen, setCustModalOpen] = useState(false);
    const [roomModalOpen, setRoomModalOpen] = useState(false);
    const [payModalOpen, setPayModalOpen] = useState(false);
    const [extendModalOpen, setExtendModalOpen] = React.useState(false);
    const [reduceModalOpen, setReduceModalOpen] = React.useState(false);
    const [exchangeModalOpen, setExchangeModalOpen] = React.useState(false);
    const [exchangeItem, setExchangeItem] = React.useState(null);
    const [returnPaymentOpen, setReturnPaymentOpen] = React.useState(false);
    const [checkoutOpen, setCheckoutOpen] = React.useState(false);
    const [paymodeEditOpen, setPaymodeEditOpen] = React.useState(false);
    const [editingId, setEditingId] = React.useState(null);

    const [propertyId, setPropertyId] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const { documentId } = useParams();
    const [services, setservices] = useState([]);

    const [bookingrooms, setbookingrooms] = useState([]);
    const [roomtypes, setroomtypes] = useState([]);
    const [rooms, setrooms] = useState([]);
    const [plans, setplans] = useState([]);
    const [itemDetails, setitemDetails] = useState([]);
    const [username, setusername] = useState("");

    const [extendRoom, setextendRoom] = useState(0)

    const [bookingServices, setBookingServices] = useState([]);
    const [checkindetails, setcheckindetails] = useState([]);
    const [bookingData, setbookingData] = useState([]);
    const [extraservices, setextraservices] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [paymode1, setpaymode1] = useState("");
    const [entryTiming, setentryTiming] = useState(0);
    const [amount1, setamount1] = useState(0);
    const [paytime1, setpaytime1] = useState(moment().format('YYYY-MM-DD HH:mm A'));
    const [paymode2, setpaymode2] = useState("");
    const [amount2, setamount2] = useState(0);
    const [paytime2, setpaytime2] = useState("");
    const [serviceamount, setserviceamount] = useState(0);
    const [rooamount, setrooamount] = useState(0);
    const [roundoff, setroundoff] = useState(0);
    const [totalamount, settotalamount] = useState(0);
    const [advance, setadvance] = useState(0);
    const [remaining, setremaining] = useState(0)
    const [note, setnote] = useState("")

    const [serviceid, setserviceid] = useState("");
    const [roomid, setroomid] = useState("");
    const [servamount, setservamount] = useState("");
    const [quantity, setquantity] = useState(1);
    const [discountupto, setdiscountupto] = useState(10);
    const [discount, setdiscount] = useState(0);
    const [servicerate, setservicerate] = useState(0);

    const [custname, setcustname] = useState("");
    const [mobile, setmobile] = useState("");
    const [email, setemail] = useState("");
    const [address, setaddress] = useState("");
    const [city, setcity] = useState("");
    const [state, setstate] = useState("");
    const [gender, setgender] = useState("Male");
    const [visitpurpose, setvisitpurpose] = useState("Darshan");
    const [gstname, setgstname] = useState("");
    const [gstno, setgstno] = useState("");
    const [bookingsource, setbookingsource] = useState("Walking");
    const [documenttype, setdocumenttype] = useState("");
    const [idno, setidno] = useState("");
    const [adults, setadults] = useState("");
    const [childs, setchilds] = useState("");

    const [rtypeid, setrtypeid] = useState("");
    const [planid, setplanid] = useState("");
    const [amount, setamount] = useState(0);
    const [roomrate, setroomrate] = useState(0);

    const [damageamount, setdamageamount] = useState(0);
    const [damagenote, setdamagenote] = useState("");
    const [anydamage, setanydamage] = useState("No");

    const [exchangeNote, setexchangeNote] = useState("");
    const [durtyRoom, setdurtyRoom] = useState("Yes");

    const [pdfURL, setPdfURL] = useState("");


    const [roomtotal, setroomtotal] = useState(0);
    const [servicetotal, setservicetotal] = useState(0);
    const [cgst, setcgst] = useState(0);
    const [subtotal, setsubtotal] = useState(0);
    const [amountInWords, setAmountInWords] = useState("");

    const [paymodeid, setpaymodeid] = useState("");
    const [uppaymode1, setuppaymode1] = useState("");
    const [uppaymode2, setuppaymode2] = useState("");

    useEffect(() => {
        return onAuthStateChanged(auth, async (user) => {
            if (!user) return;
            const snap = await getDocs(collection(db, "authroles"));
            snap.forEach((d) => { if (d.id === user.uid) setPropertyId(d.data().propertyId); });
        });

    }, []);


    useEffect(() => {
        if (propertyId) { fetchData1(); }
    }, [propertyId]);



    const fetchData1 = async () => {
        try {
            if (!documentId || !propertyId) return;

            const bookingRef = doc(db, "reservations", documentId);

            /* ================= FETCH BASE DATA (PARALLEL) ================= */
            const [
                bookingSnap,
                extraservicesSnap,
                roomsSnap,
                paymentModesSnap,
                checkinSnap,
                payHistorySnap,
                bookingServicesSnap
            ] = await Promise.all([

                // Booking
                getDoc(bookingRef),

                // Extra Services
                getDocs(
                    query(
                        collection(db, "extraservices"),
                        where("propertyId", "==", propertyId),
                        where("status", "==", "active")
                    )
                ),

                // Rooms
                getDocs(
                    query(
                        collection(db, "rooms"),
                        where("propertyId", "==", propertyId),

                    )
                ),

                // Payment Modes
                getDocs(
                    query(
                        collection(db, "paymentmodes"),
                        orderBy('createdAt', 'asc'),
                        where("propertyId", "==", propertyId)
                    )
                ),

                // Check-in Details
                getDocs(
                    query(
                        collection(db, "checkindetails"),
                        orderBy('createdAt', 'asc'),
                        where("bookingid", "==", documentId)
                    )
                ),

                // Pay History
                getDocs(
                    query(
                        collection(db, "payhistory"),
                        where("bookingid", "==", documentId)
                    )
                ),

                // Pay History
                getDocs(
                    query(
                        collection(db, "bookingservices"),
                        where("bookingid", "==", documentId)
                    )
                )
            ]);

            /* ================= BOOKING ================= */
            if (!bookingSnap.exists()) throw new Error("Booking not found!");

            const bookingData = bookingSnap.data();
            setbookingData(bookingData);

            if (bookingData.createdAt) {
                setentryTiming(
                    moment(bookingData.createdAt.toDate()).format("DD/MM/YYYY hh:mm:ss A")
                );
            }

            /* ================= EXTRA SERVICES ================= */
            setextraservices(
                extraservicesSnap.docs.map(d => ({
                    id: d.id,
                    ...d.data()
                }))
            );

            /* ================= ROOMS ================= */
            setroomtypes(
                roomsSnap.docs.map(d => ({
                    id: d.id,
                    ...d.data()
                }))
            );

            /* ================= PAYMENT MODES ================= */
            const paymentModes = paymentModesSnap.docs.map(d => ({
                id: d.id,
                ...d.data()
            }));

            setpaymodes(paymentModes);
            setpaymode1(paymentModes[0]?.id || null);
            setpaymode2(paymentModes[0]?.id || null);

            /* ================= CHECK-IN DETAILS ================= */
            setcheckindetails(
                checkinSnap.docs.map(d => ({
                    id: d.id,
                    ...d.data()
                }))
            );

            /* ================= ROOMS ================= */
            const services = bookingServicesSnap.docs.flatMap(doc => {
                const data = doc.data();
                return data.oldservices || [];
            });

            setBookingServices(services);

            /* ================= PAY HISTORY (OPTIMIZED) ================= */
            const payHistoryRaw = payHistorySnap.docs.map(d => ({
                id: d.id,
                ...d.data()
            }));

            // Collect unique payment mode IDs
            const paymodeIds = [
                ...new Set(
                    payHistoryRaw.flatMap(p => [p.paymode1, p.paymode2]).filter(Boolean)
                )
            ];

            // Fetch required payment modes only once
            const paymodeDocs = await Promise.all(
                paymodeIds.map(id => getDoc(doc(db, "paymentmodes", id)))
            );

            const paymodeMap = {};
            paymodeDocs.forEach((snap, i) => {
                if (snap.exists()) {
                    paymodeMap[paymodeIds[i]] = snap.data().paymode;
                }
            });

            // Format history
            const formattedPayHistory = payHistoryRaw.map(p => ({
                ...p,
                paymode1: paymodeMap[p.paymode1] || "",
                paymode2: paymodeMap[p.paymode2] || "",
                createdat: p.createdAt
                    ? moment(p.createdAt.toDate()).format("DD-MM-YYYY HH:mm:ss")
                    : ""
            }));

            setpayhistory(formattedPayHistory);

            /* ================= CALCULATIONS ================= */
            const roomRate = parseFloat(bookingData.rooamount || 0);
            const days = parseFloat(bookingData.noofdays || 0);

            const roomTotal = roomRate * days;
            const roomTax = roomTotal * 0.5;

            const serviceTotal = parseFloat(bookingData.serviceamount || 0);
            const totalAmount = parseFloat(bookingData.totalamount || 0);

            const subtotal = totalAmount - roomTax;
            const cgst = roomTax / 2;

            setroomtotal(roomTotal.toFixed(2));
            setservicetotal(serviceTotal.toFixed(2));
            setsubtotal(subtotal.toFixed(2));
            setcgst(cgst.toFixed(2));

            /* ================= AMOUNT IN WORDS ================= */
            setAmountInWords(numberToWords.toWords(totalAmount));

        } catch (error) {
            console.error("Fetch Error:", error);
            Toast.fire({
                icon: "error",
                title: error.message || "Failed to load booking data"
            });
        }
    };




    const handleamount1 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(value) + parseFloat(amount2);
        if (parseFloat(advance) > parseFloat(serviceamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + serviceamount });
            setadvance(0);
            setamount1(0)
            let rem = parseFloat(serviceamount) - parseFloat(amount2);
            setremaining(rem.toFixed(0))
            return;
        }
        setamount1(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(serviceamount) - parseFloat(advance);
        setremaining(rem.toFixed(0))

    }

    const handleamount2 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(amount1) + parseFloat(value);
        if (parseFloat(advance) > parseFloat(serviceamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + serviceamount });
            setadvance(0);
            setamount2(0)
            let rem = parseFloat(serviceamount) - parseFloat(amount1);
            setremaining(rem.toFixed(0))
            return;
        }

        setamount2(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(serviceamount) - parseFloat(advance);
        setremaining(rem.toFixed(0))
    }

    const handleamountx1 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(value) + parseFloat(amount2);

        if (!value || isNaN(remaining) || isNaN(advance)) {
            setamount1(parseFloat(totalamount) - parseFloat(amount2))
            setadvance(parseFloat(totalamount) - parseFloat(amount2));
            let rem = 0;
            setremaining(rem.toFixed(0))
        }
        else {
            setamount1(value)
            setadvance(parseFloat(amount2) + parseFloat(value));
            let rem = parseFloat(totalamount) - (parseFloat(amount2) + parseFloat(value));
            setremaining(rem.toFixed(0))
        }

        // } else {
        //     if (parseFloat(advance) > parseFloat(totalamount)) {
        //         // Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + totalamount });
        //         setadvance(0);
        //         setremaining(totalamount)
        //         return;
        //     }
        //     setamount1(value)
        //     setadvance(advance);
        //     let rem = parseFloat(totalamount) - parseFloat(advance);
        //     setremaining(rem.toFixed(0))
        // }

    }

    const handleamountx2 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(amount1) + parseFloat(value);
        if (!value || isNaN(remaining) || isNaN(advance)) {
            setamount2(totalamount)
            setadvance(advance.toFixed(2));
            let rem = parseFloat(totalamount) - parseFloat(advance);
            setremaining(rem.toFixed(0))
        }
        if (parseFloat(remaining) < 0) {
            setamount2(parseFloat(totalamount) - parseFloat(amount1))
            setadvance(advance);
            let rem = parseFloat(totalamount) - parseFloat(advance);
            setremaining(rem.toFixed(0))
        } else {
            if (parseFloat(advance) > parseFloat(totalamount)) {
                // Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + totalamount });
                setadvance(0);
                setremaining(totalamount)
                return;
            }
            setamount2(value)
            setadvance(advance);
            let rem = parseFloat(totalamount) - parseFloat(amount1);
            setremaining(rem.toFixed(0))
        }

    }

    const handleamount3 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(value) + parseFloat(amount2);
        if (parseFloat(advance) > parseFloat(rooamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + rooamount });
            setadvance(0);
            setamount1(0)
            let rem = parseFloat(rooamount) - parseFloat(amount2);
            setremaining(rem.toFixed(0))
            return;
        }
        setamount1(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(rooamount) - parseFloat(advance) + parseFloat(bookingData.remaining);
        setremaining(rem.toFixed(0))
    }

    const handleamount4 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(amount1) + parseFloat(value);
        if (parseFloat(advance) > parseFloat(rooamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + rooamount });
            setadvance(0);
            setamount2(0)
            let rem = parseFloat(rooamount) - parseFloat(amount1);
            setremaining(rem.toFixed(0))
            return;
        }

        setamount2(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(rooamount) - parseFloat(advance) + parseFloat(bookingData.remaining);
        setremaining(rem.toFixed(0))
    }

    const handleamount5 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(value) + parseFloat(amount2);
        if (parseFloat(advance) > parseFloat(totalamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + totalamount });
            setadvance(0);
            setamount1(0)
            let rem = parseFloat(totalamount) - parseFloat(amount2);
            setremaining(rem.toFixed(0))
            return;
        }
        setamount1(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(totalamount) - parseFloat(advance);
        setremaining(rem.toFixed(0))

    }

    const handleamount6 = (e) => {
        let value = e.target.value;
        let advance = parseFloat(amount1) + parseFloat(value);
        if (parseFloat(advance) > parseFloat(totalamount)) {
            Toast.fire({ icon: "error", title: 'Advance amount should be greater than ' + totalamount });
            setadvance(0);
            setamount2(0)
            let rem = parseFloat(totalamount) - parseFloat(amount1);
            setremaining(rem.toFixed(0))
            return;
        }

        setamount2(parseFloat(value, 10))
        setadvance(advance.toFixed(2));
        let rem = parseFloat(totalamount) - parseFloat(advance);
        setremaining(rem.toFixed(0))
    }

    const removeItem = (itemToRemove) => {
        if (window.confirm(`Are you sure you want to remove`)) {
            const updatedItems = services.filter((item) => item !== itemToRemove);
            setservices(updatedItems);

            let tamount = 0;
            for (let i = 0; i < updatedItems.length; i++) {
                tamount = parseFloat(tamount) + parseFloat(updatedItems[i].servicerate);
            }
            let rxamount = parseFloat(bookingData.noofdays) * parseFloat(tamount);
            setserviceamount(rxamount.toFixed(2))
            let rem = parseFloat(rxamount) - parseFloat(advance)
            setremaining(rem.toFixed(0))
        }
    };

    const removeItem1 = (itemToRemove) => {
        if (window.confirm(`Are you sure you want to remove1`)) {
            const updatedItems = bookingrooms.filter((item) => item !== itemToRemove);
            setbookingrooms(updatedItems);

            let tamount = 0;
            for (let i = 0; i < updatedItems.length; i++) {
                tamount = parseFloat(tamount) + parseFloat(updatedItems[i].roomrate);
            }
            let rxamount = parseFloat(bookingData.noofdays) * parseFloat(tamount);
            setrooamount(rxamount.toFixed(2))
            let rem = parseFloat(rxamount) - parseFloat(advance)
            setremaining(rem.toFixed(0))
        }
    };

    const handleServiceArray = async () => {

        let num1 = quantity.toString();
        let num2 = discount.toString();

        if (!roomid || !serviceid || !servamount || !num1 || !num2 || !servicerate) {
            Toast.fire({ icon: "error", title: 'Required all fields' });
            return;
        }

        let roomno;
        let servicename;

        const docRef = doc(db, "roominfos", roomid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            roomno = docSnap.data().roomNo;
        } else {
            roomno = "";
        }

        const docRef1 = doc(db, "extraservices", serviceid);
        const docSnap1 = await getDoc(docRef1);
        if (docSnap1.exists()) {
            servicename = docSnap1.data().servicename;
        } else {
            servicename = "";
        }


        const newItem = { roomid, serviceid, servamount, quantity, discount, servicerate, roomno, servicename, username: username };

        setservices([...services, newItem]);
        setserviceid("");
        setroomid("");
        setservamount(0);
        setquantity(1);
        setdiscountupto(10);
        setdiscount(0);
        setservicerate(0);

        let tamount = 0;
        for (let i = 0; i < services.length; i++) {
            tamount = parseFloat(tamount) + parseFloat(services[i].servicerate);
        }
        let rxamount = parseFloat(tamount) + parseFloat(servicerate);
        let newamount = parseFloat(rxamount)
        setserviceamount(newamount.toFixed(2))
        let rem = parseFloat(newamount) - parseFloat(advance)
        setremaining(rem.toFixed(0))
    }


    function caltotal(qty, dis, amnt) {
        let rtot = parseFloat(qty) * parseFloat(amnt);
        let discount = parseFloat(rtot) * parseFloat(dis) / 100;
        let dirate = parseFloat(rtot) - parseFloat(discount);
        dirate = parseFloat(dirate)
        setservicerate(dirate.toFixed(2));

    }


    const handleServiceid = async (e) => {
        setserviceid(e.target.value);
        const docRef1 = doc(db, "extraservices", e.target.value);
        const docSnap1 = await getDoc(docRef1);
        if (docSnap1.exists()) {
            setservamount(docSnap1.data().amount);
            caltotal(quantity, discount, docSnap1.data().amount)
        } else {
            setservamount(0);
            caltotal(quantity, discount, 0)
        }
    }

    const handleQuantity = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (parseFloat(value) < 1 || !value) {
            caltotal(1, discount, servamount)
            setquantity(1);
        } else {
            caltotal(value, discount, servamount)
            setquantity(value)
        }
    }

    const handleDiscount = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (parseFloat(value < 0) || !value) {
            setdiscount(0)
        }
        if (parseFloat(value) > parseFloat(discountupto)) {
            Toast.fire({ icon: "error", title: 'Discount should be greater than ' + discountupto });
            setdiscount(discountupto);
            caltotal(quantity, discountupto, servamount)
            return;
        }
        else {
            setdiscount(value);
            caltotal(quantity, value, servamount)
        }
    }

    const storeService = async () => {
        setIsLoading(true)

        if (!services) {
            Toast.fire({ icon: "error", title: 'Please Select at least 1 Service' });
            return
        }

        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }
        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }


        const docRef = doc(db, "reservations", documentId);
        const docSnap = await getDoc(docRef);
        let oldservices = []
        if (docSnap.exists()) {
            let totalt = parseFloat(serviceamount) + parseFloat(docSnap.data().totalamount);
            let totals = parseFloat(serviceamount) + parseFloat(docSnap.data().serviceamount);
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(remaining) + parseFloat(docSnap.data().remaining);

            for (let i = 0; i < docSnap.data().services.length; i++) {
                oldservices.push(docSnap.data().services[i]);
            }

            for (let i = 0; i < services.length; i++) {
                oldservices.push(services[i]);
            }

            await updateDoc(doc(db, "reservations", documentId), {
                serviceamount: parseFloat(totals),
                totalamount: parseFloat(totalt),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
            });

            await addDoc(collection(db, 'bookingservices'), {
                bookingid: documentId,
                customerId: docSnap.data().customerId,
                customers: docSnap.data().customers,
                uid: userData.uid,
                createdAt: Timestamp.now(),
                oldservices,
                type: "Booking",
            });

            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    note: note,
                    paymenttype: "B",
                    uid: userData.uid,
                    username: username,
                    type: 'Extra Service',
                    status: 'Working',
                    createdAt: Timestamp.now(),
                });
            }

            setserviceid(""); setroomid(""); setservamount(""); setquantity(1); setdiscountupto(10);
            setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2("");
            setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote("")
            Toast.fire({ icon: "success", title: 'Extra services successfully added' });
        }
        setIsLoading(false)
    }

    const getCustData = () => {
        setcustname(bookingData.customers.custname);
        setmobile(bookingData.customers.mobile);
        setemail(bookingData.customers.email);
        setaddress(bookingData.customers.address);
        setcity(bookingData.customers.city);
        setstate(bookingData.customers.state);
        setgender(bookingData.customers.gender);
        setgstname(bookingData.customers.gstname);
        setgstno(bookingData.customers.gstno);
        setdocumenttype(bookingData.customers.documenttype);
        setidno(bookingData.customers.idno);
        setvisitpurpose(bookingData.visitpurpose);
        setbookingsource(bookingData.bookingsource);
        setadults(bookingData.adults);
        setchilds(bookingData.childs);
    }

    const updateCust = async () => {
        const customerData = {
            custname: custname,
            mobile: mobile,
            email: email,
            address: address,
            city: city,
            state: state,
            gender: gender,
            gstname: gstname,
            gstno: gstno,
            documenttype: documenttype,
            idno: idno,
            uid: userData.uid,
            createdAt: Timestamp.now(),
        };

        await updateDoc(doc(db, "reservations", documentId), {
            customers: customerData,
            bookingsource: bookingsource,
            visitpurpose: visitpurpose,
            adults: adults,
            childs: childs,
        });

        await updateDoc(doc(db, "customers", bookingData.customerId), {
            customers: customerData,
            bookingsource: bookingsource,
            visitpurpose: visitpurpose,
        });
        fetchData1()
        Toast.fire({ icon: "success", title: 'Customer Details Successfully Updated' });

    }

    const handlemobile = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length <= 10) {
            setmobile(value);
        }

    }


    const handleroomtypeChange = (value) => {
        setrtypeid(value);
        setamount(0);
        setroomrate(0);
        setdiscount(0);
        setdiscountupto(0);
        settotalamount(0);
        setrooamount(0)
        setadvance(0)
        setremaining(0)

        const q = query(collection(db, 'roominfos'), where('roomTypeId', '==', value))
        onSnapshot(q, (querySnapshot) => {
            setrooms(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));
        });

        const q1 = query(collection(db, 'roomrates'), where('roomId', '==', value))
        onSnapshot(q1, (querySnapshot) => {
            setplans(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })));
        });
    }

    const handleplanChange = async (value) => {
        setplanid(value);
        try {
            const userDocRef = doc(db, 'roomrates', value);
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
                let rohaamount = parseFloat(userDocSnap.data().amount);
                setamount(rohaamount.toFixed(2));
                setroomrate(rohaamount.toFixed(2));
                setdiscount(0);
                setdiscountupto(userDocSnap.data().discount);
            } else {
                // Toast.fire({
                //     icon: "error",
                //     title: 'No Data Found'
                // });

            }
        } catch (error) {
            console.error('Error fetching document:', error);
        }
    }

    const handleplanChange1 = async (value) => {
        setamount(0);
        setroomrate(0);
        setrooamount(0);
        setremaining(0);
        setdiscount(0);
        setdiscountupto(0);
        setplanid(value);
        try {
            console.log(itemDetails);

            const userDocRef = doc(db, 'roomrates', value);
            const userDocSnap = await getDoc(userDocRef);
            if (userDocSnap.exists()) {
                let xAmount = parseFloat(userDocSnap.data().rate) - parseFloat(itemDetails.roomrate);
                let rohaxamount = parseFloat(userDocSnap.data().rate);
                setamount(rohaxamount.toFixed(2));
                setroomrate(rohaxamount.toFixed(2));
                setrooamount(xAmount.toFixed(2));
                setremaining(xAmount.toFixed(2));
                setdiscount(0);
            } else {

            }
        } catch (error) {
            console.error('Error fetching document:', error);
        }
    }

    const handleRoomArray = () => {
        if (!roomid || !rtypeid || !planid || !amount || !roomrate) {
            Toast.fire({ icon: "error", title: "All fields are required" });
            return;
        }

        try {
            // 🔹 Match Room
            const matchedRoom = rooms.find(r => r.id === roomid);

            const roomno = matchedRoom?.data?.roomNo || "";
            const roomtypename = matchedRoom?.data?.roomTypeName || "";
            const roomTypeId = matchedRoom?.data?.roomTypeId || rtypeid;

            // 🔹 Match Plan
            const matchedPlan = plans.find(p => p.id === planid);
            const planname = matchedPlan?.data?.planName || "";

            // 🔹 New room item (KEEP NUMBERS AS NUMBERS)
            const newItem = {
                roomid,
                roomno,
                rtypeid: roomTypeId,
                roomtypename,
                planid,
                planname,
                amount: Number(amount),
                discount: Number(discount || 0),
                roomrate: Number(roomrate),
            };

            // 🔹 Update rooms array
            const updatedRooms = [...bookingrooms, newItem];
            setbookingrooms(updatedRooms);

            // 🔹 Rooms count
            // setnoofrooms(updatedRooms.length);

            // 🔹 Calculate total room rate
            const totalRoomAmount = updatedRooms.reduce(
                (sum, r) => sum + Number(r.roomrate),
                0
            );

            setrooamount(totalRoomAmount.toFixed(2));
            let rem = parseFloat(totalRoomAmount) - parseFloat(advance)
            setremaining(rem.toFixed(0))
            // 🔹 Final bill calculation
            calFinalTotal(bookingData.noofdays, totalRoomAmount);

            // 🔹 Reset form
            setrtypeid("");
            setroomid("");
            setplanid("");
            setamount("");
            setdiscount("");
            setdiscountupto(0);
            setroomrate("");

        } catch (error) {
            console.error("Error adding room:", error);
            Toast.fire({ icon: "error", title: "Something went wrong" });
        }
    };


    const calFinalTotal = (days, roomamountxx) => {
        let total = parseFloat(days) * parseFloat(roomamountxx)
        settotalamount(total.toFixed(0));
        let roundoff = total.toFixed(2) - total.toFixed(0);
        setroundoff(parseFloat(roundoff).toFixed(2));
    }

    const emptyRooms = () => {
        setamount1(0); setpaytime1(" "); setamount2(0); setpaytime2(" ");
        setserviceamount(0); setrooamount(0); setroundoff(0); settotalamount(0); setadvance(0); setremaining(0);
        setbookingrooms([]); setservices([]); setextendRoom(0)
    }
    const emptyRooms1 = () => {
        setamount1(0); setpaytime1(" "); setamount2(0); setpaytime2(" ");
        setserviceamount(0); setrooamount(0); setadvance(0); setbookingrooms([]); setservices([]); setroundoff(bookingData.roundoff);
        settotalamount(bookingData.remaining.toFixed(0)); setremaining(bookingData.remaining.toFixed(0));
    }
    const emptyRooms2 = (item) => {
        setitemDetails(item); setrtypeid(""); setroomid(""); setplanid(""); setamount(0); setdiscountupto(0); setdiscount(0); setroomrate(0); setamount1(0);
        setpaytime1(" "); setamount2(0); setpaytime2(" "); setserviceamount(0); setrooamount(0); settotalamount(0); setadvance(0); setremaining(0);
        setbookingrooms([]); setservices([]); setextendRoom(0); setroundoff(0)
    }

    const emptyRooms3 = () => {
        setamount1(0); setpaytime1(" "); setamount2(0); setpaytime2(" ");
        setserviceamount(0); setrooamount(0); setadvance(0); setbookingrooms([]); setservices([]); setroundoff(bookingData.roundoff);
        settotalamount(bookingData.restoamount.toFixed(0)); setremaining(bookingData.restoamount.toFixed(0));
    }

    function caltotal1(value) {
        setdiscount(value);
        if (value) {
            if (parseFloat(value) > parseFloat(discountupto)) {
                Toast.fire({ icon: "error", title: 'Discount should not be greater than ' + discountupto });
                setdiscount(discountupto);
                let roomr = parseFloat(amount) * parseFloat(discountupto) / 100;
                let xamount = (parseFloat(amount) - parseFloat(roomr));
                setroomrate(xamount.toFixed(2));
            } else {
                let roomr = parseFloat(amount) * parseFloat(value) / 100;
                let xamount = (parseFloat(amount) - parseFloat(roomr));
                setroomrate(xamount.toFixed(2));
            }
        }
        else {
            setdiscount(0)
        }
    }


    function caltotal2(value) {
        setdiscount(value);
        if (value) {
            if (parseFloat(value) > parseFloat(discountupto)) {
                Toast.fire({ icon: "error", title: 'Discount should not be greater than ' + discountupto });
                setdiscount(discountupto);
                let roomr = parseFloat(amount) * parseFloat(discountupto) / 100;
                let xamount = (parseFloat(amount) - parseFloat(roomr));
                setroomrate(xamount.toFixed(2));
                let rem = parseFloat(xamount) - parseFloat(itemDetails.roomrate);
                setrooamount(rem.toFixed(2));
            } else {
                let roomr = parseFloat(amount) * parseFloat(value) / 100;
                let xamount = (parseFloat(amount) - parseFloat(roomr));
                setroomrate(xamount.toFixed(2));
                let rem = parseFloat(xamount) - parseFloat(itemDetails.roomrate);
                setrooamount(rem.toFixed(2));
            }
        }
        else {
            setdiscount(0)
        }
    }


    const storeRoom = async () => {
        if (!rooms) {
            Toast.fire({ icon: "error", title: 'Please Select at least 1 Service' });
            return
        }

        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }

        setIsLoading(true)

        const docRef = doc(db, "reservations", documentId);
        const docSnap = await getDoc(docRef);
        let oldrooms = []
        if (docSnap.exists()) {
            let totals = (parseFloat(rooamount) / parseFloat(bookingData.noofdays)) + parseFloat(docSnap.data().rooamount);
            let totalt = parseFloat(rooamount) + parseFloat(docSnap.data().totalamount);
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(remaining) + parseFloat(docSnap.data().remaining);


            for (let i = 0; i < docSnap.data().noofdays; i++) {
                for (let j = 0; j < bookingrooms.length; j++) {
                    await addDoc(collection(db, 'checkindetails'), {
                        bookingid: documentId,
                        customerId: docSnap.data().customerId,
                        checkindate: moment(docSnap.data().checkindate).add(i, 'days').format('YYYY-MM-DD'),
                        checkoutdate: moment(docSnap.data().checkindate).add(i + 1, 'days').format('YYYY-MM-DD'),
                        roomid: bookingrooms[j].roomid,
                        roomtypeid: bookingrooms[j].rtypeid,
                        planid: bookingrooms[j].planid,
                        roomno: bookingrooms[j].roomno,
                        planname: bookingrooms[j].planname,
                        roomtype: bookingrooms[j].roomtypename,
                        uid: userData.uid,
                        username: username,
                        status: 'Booked',
                        createdAt: Timestamp.now(),
                    });
                }
            }

            for (let i = 0; i < docSnap.data().rooms.length; i++) {
                oldrooms.push(docSnap.data().rooms[i]);
            }
            for (let i = 0; i < bookingrooms.length; i++) {
                oldrooms.push(bookingrooms[i]);
            }


            await updateDoc(doc(db, "reservations", documentId), {
                rooms: oldrooms,
                rooamount: parseFloat(totals),
                totalamount: parseFloat(totalt),
                roundoff: parseFloat(roundoff),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
                noofrooms: oldrooms.length
            });

            await addDoc(collection(db, 'bookingrooms'), {
                bookingid: documentId,
                customerId: docSnap.data().customerId,
                customers: docSnap.data().customers,
                uid: userData.uid,
                createdAt: Timestamp.now(),
                bookingrooms,
            });

            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    note: note,
                    paymenttype: "B",
                    uid: userData.uid,
                    username: username,
                    type: 'New Room Payments',
                    status: 'Working',
                    createdAt: Timestamp.now(),
                });
            }

            for (let i = 0; i < oldrooms.length; i++) {
                await updateDoc(doc(db, "roominfos", oldrooms[i].roomid), {
                    status: "Booked",
                });
            }


            setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
            setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
            setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
            setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
            Toast.fire({ icon: "success", title: 'New Rooms successfully added' });
        }

        setIsLoading(false)
    }

    const storePayment = async () => {
        setIsLoading(true)
        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }
        const docRef = doc(db, "reservations", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(docSnap.data().totalamount) - parseFloat(totalp);

            await updateDoc(doc(db, "reservations", documentId), {
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
            });
            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    paymenttype: "B",
                    note: note,
                    uid: userData.uid,
                    username: username,
                    status: 'Working',
                    type: 'Payments Taken from Customers',
                    createdAt: Timestamp.now(),
                });
            }
        }

        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Payment successfully added' });
        setIsLoading(false)
    }

    const storePayment1 = async () => {
        setIsLoading(true)
        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }
        const docRef = doc(db, "reservations", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let totalp = parseFloat(docSnap.data().advance) + parseFloat(advance);
            let totalr = parseFloat(docSnap.data().totalamount.toFixed(2)) - parseFloat(totalp.toFixed(2));


            await updateDoc(doc(db, "reservations", documentId), {
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
            });
            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    note: note,
                    uid: userData.uid,
                    username: username,
                    status: 'Working',
                    paymenttype: "B",
                    type: 'Payments given to Customers',
                    createdAt: Timestamp.now(),
                });
            }
        }

        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Payment successfully added' });
        setIsLoading(false)
    }

    const storeRestoPayment = async () => {
        setIsLoading(true)
        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }
        const docRef = doc(db, "reservations", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(docSnap.data().totalamount) - parseFloat(totalp);

            await updateDoc(doc(db, "reservations", documentId), {
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
            });

            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    paymenttype: "B",
                    note: note,
                    uid: userData.uid,
                    username: username,
                    status: 'Working',
                    type: 'Payments Taken from Customers',
                    createdAt: Timestamp.now(),
                });
            }
        }

        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Food Amount Successfully Paid' });
        setIsLoading(false)
    }

    const handleExtendRoom = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length <= 2 || value) {
            setextendRoom(value);
            let tot = parseFloat(value) * (parseFloat(bookingData.rooamount));
            settotalamount(tot.toFixed(0));
            setremaining(tot.toFixed(0));
            let roundoff = tot.toFixed(2) - tot.toFixed(0);
            setroundoff(parseFloat(roundoff).toFixed(2));
        }
    }

    const handleReduceRoom = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length <= 2 || value) {
            if (parseFloat(value) >= bookingData.noofdays) {
                Toast.fire({ icon: "error", title: 'No of days should not be less than or equal to ' + bookingData.noofdays });
                let ramm = bookingData.noofdays - 1;
                setextendRoom(ramm);
                let tot = parseFloat(ramm) * (parseFloat(bookingData.rooamount) + parseFloat(bookingData.serviceamount));
                settotalamount(tot.toFixed(0));
                return
            }
            setextendRoom(value);
            let tot = parseFloat(value) * (parseFloat(bookingData.rooamount) + parseFloat(bookingData.serviceamount));
            settotalamount(tot.toFixed(0));
        }
    }

    const extendRoomStore = async () => {
        setIsLoading(true)
        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            return
        }
        if (extendRoom < 1 || !extendRoom) {
            Toast.fire({ icon: "error", title: 'Please Enter No of day ' });
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                return
            }
        }
        const docRef = doc(db, "reservations", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let totala = parseFloat(totalamount) + parseFloat(docSnap.data().totalamount);
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(totala) - parseFloat(totalp)
            let roundofff = parseFloat(totala).toFixed(2) - parseFloat(totala).toFixed(0);

            let checkout = moment(bookingData.checkoutdate).add(extendRoom, 'days').format('YYYY-MM-DD')
            await updateDoc(doc(db, "reservations", documentId), {
                totalamount: parseFloat(totala),
                roundoff: parseFloat(roundofff),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
                checkoutdate: checkout,
                noofdays: parseFloat(bookingData.noofdays) + parseFloat(extendRoom),
            });
            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    paymenttype: "B",
                    note: note,
                    uid: userData.uid,
                    status: 'Working',
                    type: 'Room Extension Payment',
                    username: username,
                    createdAt: Timestamp.now(),
                });
            }

            for (let i = 0; i < extendRoom; i++) {
                for (let j = 0; j < bookingData.rooms.length; j++) {
                    await addDoc(collection(db, 'checkindetails'), {
                        bookingid: documentId,
                        customerId: bookingData.customerId,
                        checkindate: moment(bookingData.checkoutdate).add(i, 'days').format('YYYY-MM-DD'),
                        checkoutdate: moment(bookingData.checkoutdate).add(i + 1, 'days').format('YYYY-MM-DD'),
                        roomid: bookingData.rooms[j].roomid,
                        roomtypeid: bookingData.rooms[j].rtypeid,
                        planid: bookingData.rooms[j].planid,
                        roomno: bookingData.rooms[j].roomno,
                        planname: bookingData.rooms[j].planname,
                        roomtype: bookingData.rooms[j].roomtypename,
                        uid: userData.uid,
                        username: username,
                        status: 'Booked',
                        createdAt: Timestamp.now(),
                    });
                }
            }
        }

        await addDoc(collection(db, 'logs'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            rooms: bookingData.rooms,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Room Extended ',
        });

        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Room Successfully Extended  ' });
        setIsLoading(false)
    }


    const reduceRoomStore = async () => {


        const docRef = doc(db, "reservations", documentId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            let totala = parseFloat(docSnap.data().totalamount) - parseFloat(totalamount);
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(totala) - parseFloat(totalp)
            let roundofff = parseFloat(totala).toFixed(2) - parseFloat(totala).toFixed(0);

            let checkout = moment(bookingData.checkoutdate).subtract(extendRoom, 'days').format('YYYY-MM-DD')
            await updateDoc(doc(db, "reservations", documentId), {
                totalamount: parseFloat(totala),
                roundoff: parseFloat(roundofff),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
                checkoutdate: checkout,
                noofdays: parseFloat(bookingData.noofdays) - parseFloat(extendRoom),
            });

            await addDoc(collection(db, 'logs'), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                rooms: bookingData.rooms,
                uid: userData.uid,
                username: username,
                createdAt: Timestamp.now(),
                type: 'Room Reduced ',
            });

        }

        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([])
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Room Successfully Reduced  ' });
    }

    const storeRoomExchange = async () => {
        setIsLoading(true)
        if (!roomid || !rtypeid || !planid || !amount || !roomrate) {
            Toast.fire({ icon: "error", title: 'Please select another room with amount' });
            return;
        }

        let roomno;
        let roomtypename;
        let planname;

        const docRef = doc(db, "roominfos", roomid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            roomno = docSnap.data().roomno;
        } else {
            roomno = "";
        }

        const docRef1 = doc(db, "roomtypes", rtypeid);
        const docSnap1 = await getDoc(docRef1);
        if (docSnap1.exists()) {
            roomtypename = docSnap1.data().roomtype;
        } else {
            roomtypename = "";
        }

        const docRef2 = doc(db, "roomrates", planid);
        const docSnap2 = await getDoc(docRef2);
        if (docSnap2.exists()) {
            planname = docSnap2.data().rateplan;
        } else {
            planname = "";
        }
        let newArray = [];
        const newItem1X = { roomid, rtypeid, planid, amount, discount, roomrate, roomno, roomtypename, planname, username: username, status: "Exchanged", exchangeNote: exchangeNote };
        for (let i = 0; i < bookingData.rooms.length; i++) {
            if (bookingData.rooms[i].roomid !== itemDetails.roomid) {
                newArray.push(bookingData.rooms[i])
            }
        }
        newArray.push(newItem1X);

        let newroomamount = parseFloat(bookingData.rooamount) - parseFloat(itemDetails.roomrate)

        let tttttttttttt = (parseFloat(newroomamount) + parseFloat(bookingData.serviceamount) + parseFloat(roomrate)) * parseFloat(bookingData.noofdays);
        let rem = parseFloat(tttttttttttt) - parseFloat(bookingData.advance)
        let roundofff = parseFloat(tttttttttttt).toFixed(2) - parseFloat(tttttttttttt).toFixed(0);

        await updateDoc(doc(db, "reservations", documentId), {
            totalamount: parseFloat(tttttttttttt),
            roundoff: parseFloat(roundofff).toFixed(2),
            rooamount: parseFloat(newroomamount) + parseFloat(roomrate),
            remaining: parseFloat(rem),
            rooms: newArray,
        });

        let bookingrooms = newArray;

        await addDoc(collection(db, 'bookingrooms'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            uid: userData.uid,
            createdAt: Timestamp.now(),
            bookingrooms,
        });

        await updateDoc(doc(db, "roominfos", roomid), {
            status: "Booked",
        });

        await updateDoc(doc(db, "reservations", documentId), {
            approval1: "No",
        });

        if (durtyRoom === 'Yes') {
            await updateDoc(doc(db, "roominfos", itemDetails.roomid), {
                status: "Cleaning",
            });

            await addDoc(collection(db, 'cleaningrooms'), {
                bookingid: documentId,
                roomid: itemDetails.roomid,
                roomno: itemDetails.roomno,
                uid: userData.uid,
                username: username,
                status: 'Cleaning',
                cleanedby: "",
                cleanedtime: "",
                createdAt: Timestamp.now(),
            });

        } else {
            await updateDoc(doc(db, "roominfos", itemDetails.roomid), {
                status: "Available",
            });
        }

        await addDoc(collection(db, 'logs'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            rooms: bookingData.rooms,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Room Exchanged',
        });


        const q1 = query(collection(db, 'checkindetails'), where('bookingid', '==', documentId), where('roomid', '==', itemDetails.roomid), where('checkindate', '>=', moment().format('YYYY-MM-DD')))
        onSnapshot(q1, async (querySnapshot1) => {
            for (const doc1 of querySnapshot1.docs) {
                await updateDoc(doc(db, "checkindetails", doc1.id), {
                    roomid: newItem1X.roomid,
                    roomtypeid: newItem1X.rtypeid,
                    planid: newItem1X.planid,
                    roomno: newItem1X.roomno,
                    planname: newItem1X.planname,
                    roomtype: newItem1X.roomtypename,
                });
            }
        });


        setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
        setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
        setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([]);
        setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
        Toast.fire({ icon: "success", title: 'Room Successfully Exchanged  ' })
        setIsLoading(false)
    }

    const cancleExtraService = async (item) => {

        if (window.confirm(`Are you sure you want to Cancle Extra Service`)) {
            let newArray = [];
            for (let i = 0; i < bookingData.services.length; i++) {
                if (bookingData.services[i].serviceid !== item.serviceid) {
                    newArray.push(bookingData.services[i])
                }
            }

            let newservicerate = parseFloat(item.servicerate) * parseFloat(bookingData.noofdays)
            let newrserviceamount = parseFloat(bookingData.serviceamount) - parseFloat(newservicerate)
            let newrtotamount = parseFloat(bookingData.totalamount) - parseFloat(newservicerate)
            let newRemaining = parseFloat(newrtotamount) - parseFloat(bookingData.advance)
            let roundofff = parseFloat(newrtotamount).toFixed(2) - parseFloat(newrtotamount).toFixed(0);

            await updateDoc(doc(db, "reservations", documentId), {
                totalamount: parseFloat(newrtotamount),
                roundofff: parseFloat(roundofff).toFixed(2),
                serviceamount: parseFloat(newrserviceamount),
                remaining: parseFloat(newRemaining),
                services: newArray,
            });

            let oldservices = newArray;
            await addDoc(collection(db, 'bookingservices'), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                uid: userData.uid,
                createdAt: Timestamp.now(),
                oldservices
            });

            await addDoc(collection(db, 'logs'), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                services: item,
                uid: userData.uid,
                username: username,
                createdAt: Timestamp.now(),
                type: 'Extra Service Cancled',
            });

            await updateDoc(doc(db, "reservations", documentId), {
                approval3: "No",
            });


            setrtypeid(""); setplanid(""); setamount(0); setroomrate(0); setserviceid(""); setroomid(""); setservamount("");
            setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0); fetchData1(); setservices([]); setroundoff(0);
            setpaymode1(""); setamount1(0); setpaytime1(" "); setpaymode2(""); setrooms([]); setbookingrooms([]);
            setamount2(0); setpaytime2(" "); setserviceamount(0); setadvance(0); setremaining(0); setnote(""); setrooamount(0); settotalamount(0)
            Toast.fire({ icon: "success", title: 'Extra Service Successfully Cancled ' })
        }

    }

    const handleDamageAmount = (e) => {
        if (e.target.value) {
            setdamageamount(parseFloat(e.target.value, 10));
            let tot = parseFloat(bookingData.remaining) + parseFloat(e.target.value);
            setremaining(parseFloat(tot).toFixed(0));
            settotalamount(parseFloat(tot).toFixed(0))
            let roundoff = tot.toFixed(2) - tot.toFixed(0);
            setroundoff(parseFloat(roundoff).toFixed(2));
        }
        else {
            setdamageamount(0);
            setremaining(parseFloat(bookingData.remaining));
            settotalamount(parseFloat(bookingData.remaining))
        }

    }

    const handleCheckout = async () => {

        setIsLoading(true)

        if (anydamage === 'Yes') {
            await addDoc(collection(db, 'damages'), {
                bookingid: documentId,
                customerId: bookingData.customerId,
                customers: bookingData.customers,
                rooms: bookingData.rooms,
                damageamount: damageamount,
                damagenote: damagenote,
                uid: userData.uid,
                username: username,
                createdAt: Timestamp.now(),
            });
        }

        let amt1 = amount1.toString();
        let amt2 = amount2.toString();

        if (isNaN(advance)) {
            Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
            setIsLoading(false)
            return
        }

        if (advance !== 0) {
            if (!paymode1 || !amt1 || !paymode2 || !amt2) {
                if (amount1 < 0 || amount2 < 0) {
                    Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                    setIsLoading(false)
                    return
                }
                Toast.fire({ icon: "error", title: 'Please fill required fields in payment details' });
                setIsLoading(false)
                return
            }
        }
        const docRef = doc(db, "reservations", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            let totalt = parseFloat(bookingData.totalamount) + parseFloat(damageamount);
            let totalp = parseFloat(advance) + parseFloat(docSnap.data().advance);
            let totalr = parseFloat(totalt) - parseFloat(totalp);
            let roundofff = parseFloat(totalt).toFixed(2) - parseFloat(totalt).toFixed(0);

            await updateDoc(doc(db, "reservations", documentId), {
                totalamount: parseFloat(totalt),
                roundofff: parseFloat(roundofff).toFixed(2),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
                damageamount: parseFloat(damageamount),
                status: 'Checkout',
                checkouttime: moment().format("HH:mm A"),
                extra4: moment().format("DD-MM-YYYY HH:mm A")
            });

            if (advance !== 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId,
                    customerId: docSnap.data().customerId,
                    customers: docSnap.data().customers,
                    paymode1: paymode1,
                    amount1: parseFloat(amount1),
                    paytime1: paytime1,
                    paymode2: paymode2,
                    amount2: parseFloat(amount2),
                    paytime2: paytime2,
                    note: note,
                    paymenttype: "B",
                    uid: userData.uid,
                    username: username,
                    status: 'Working',
                    type: 'Payments Taken from Customers',
                    createdAt: Timestamp.now(),
                });
            }

            const q = query(collection(db, "checkindetails"), where("bookingid", "==", documentId));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach(async (document) => {
                await updateDoc(doc(db, "checkindetails", document.id), {
                    status: "Checkout",
                });
            });

            for (let i = 0; i < bookingData.rooms.length; i++) {
                await updateDoc(doc(db, "roominfos", bookingData.rooms[i].roomid), {
                    status: "Cleaning",
                });

                await addDoc(collection(db, 'cleaningrooms'), {
                    bookingid: documentId,
                    roomid: bookingData.rooms[i].roomid,
                    roomno: bookingData.rooms[i].roomno,
                    uid: userData.uid,
                    username: username,
                    status: 'Cleaning',
                    cleanedby: "",
                    cleanedtime: "",
                    createdAt: Timestamp.now(),
                });
            }

            await addDoc(collection(db, 'checkouthistory'), {
                bookingid: documentId,
                invoiceno: docSnap.data().invoiceno,
                customerId: docSnap.data().customerId,
                customers: docSnap.data().customers,
                checkindate: bookingData.checkindate,
                checkoutdate: bookingData.checkoutdate,
                rooms: docSnap.data().rooms,
                uid: userData.uid,
                username: username,
                totalamount: parseFloat(totalt),
                advance: parseFloat(totalp),
                remaining: parseFloat(totalr),
                checkoutime: moment().format('DD/MM/YYYY HH:mm:ss A'),
                createdAt: Timestamp.now(),
            });
        }


        await addDoc(collection(db, 'logs'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Room Checkouts',
        });


        if (parseFloat(bookingData.restoamount) > 0) {

            const q = query(collection(db, 'orders'), where('bookingId', '==', documentId));
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                querySnapshot.forEach(async (docSnapshot) => {
                    const orderRef = doc(db, 'orders', docSnapshot.id);
                    await updateDoc(orderRef, {
                        status: 'Active',
                        paytype: paymode2
                    });
                });
            } else {
                console.log('No orders found for the given bookingid.');
            }

            // await updateDoc(doc(db, 'orders', orderId), {
            //     paytype: paymode2,
            //     status: "Active"
            // });
        }

        setIsLoading(false)
        setCheckoutOpen(false)
        Toast.fire({ icon: "success", title: 'Room Successfully Checkout' });
        uploadInvoiceToFirebase();

        setTimeout(() => {
            navigate("/view-reservations");
        }, 1500);

    }


    const deletCheckin = async (docid) => {
        console.log(docid);

        const taskDocRef = doc(db, 'checkindetails', docid)
        await deleteDoc(taskDocRef)
        Toast.fire({
            icon: "success",
            title: ' Deleted Successfully!!'
        });
        fetchData1();


        await addDoc(collection(db, 'logs'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            rooms: bookingData.rooms,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Checkin Delete',
        });
    }

    const deletPyament = async (docid) => {
        console.log(docid);

        const taskDocRef = doc(db, 'payhistory', docid)
        await deleteDoc(taskDocRef)
        Toast.fire({
            icon: "success",
            title: ' Deleted Successfully!!'
        });
        fetchData1();


        await addDoc(collection(db, 'logs'), {
            bookingid: documentId,
            customerId: bookingData.customerId,
            customers: bookingData.customers,
            rooms: bookingData.rooms,
            uid: userData.uid,
            username: username,
            createdAt: Timestamp.now(),
            type: 'Payment History Deleted',
        });
    }

    const hanldeServeAmount = (e) => {
        setservamount(e.target.value);
        setservamount(e.target.value);
        caltotal(quantity, discount, e.target.value)
    }


    const uploadInvoiceToFirebase = async () => {
        try {
            const pdfBlob = await pdf(<InvoicePDF invoiceData={documentId} />).toBlob();

            const storageRef = ref(storage, `invoices/invoice_${Date.now()}.pdf`);
            const uploadTask = uploadBytesResumable(storageRef, pdfBlob);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    console.log(`Progress: ${(snapshot.bytesTransferred / snapshot.totalBytes) * 100}%`);
                },
                (error) => {
                    console.error("Upload failed:", error);
                },
                async () => {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    setPdfURL(downloadURL);

                    const querySnapshot = await getDocs(collection(db, "whatsapp"));

                    if (!querySnapshot.empty) {
                        const firstDoc = querySnapshot.docs[0].data(); // Get first document
                        if (firstDoc.status === 'ON') {
                            if (firstDoc.mobile === 'ROHAN') {
                                // sendWhatsAppMessage(8459432930, downloadURL)
                            }
                            else {
                                // sendWhatsAppMessage(8459432930, downloadURL)
                                sendWhatsAppMessage(bookingData.customers.mobile, downloadURL)
                            }
                        }
                    }
                    console.log("Invoice uploaded:", downloadURL);
                }
            );
        } catch (error) {
            console.error("Error generating/uploading PDF:", error);
        }
    }


    const sendWhatsAppMessage = async (mobileno, downloadURL) => {
        const wabaid = "591801274016500";
        const accesstoken = "EAAIYwoDRSHsBO6o4NeCQr0f1v9PrWvvI31boSykl9sGxFX4xZBzznLazzVm9LbaqNrBYSZAjccUUwjBohCovlp5l5RwESrnk3fkZCzLjNRVAbptz591adwdjQyZBx3FcMnIfAzz1oZBO1QxldkLzgOrR77KuDxfSz3vCFSZAy2Tz0s5RFmkUN5DbljSdn7N5qI6AZDZD";

        // Payload to send message
        const payload = {
            messaging_product: 'whatsapp',
            recipient_type: 'individual',
            to: '91' + mobileno, // Customer's phone number with country code
            type: 'template',
            template: {
                name: 'invoice_tamplate', // Replace with the actual approved template name
                language: {
                    code: 'en_US', // Language code used in the template
                },

                components: [
                    {
                        type: 'header',
                        parameters: [
                            {
                                type: "document",
                                document: {
                                    link: downloadURL,
                                    filename: 'Invoice.pdf'
                                }
                            }
                        ]
                    }
                ],
            },
        };

        // Sending the message
        try {
            const response = await fetch(`https://graph.facebook.com/v20.0/${wabaid}/messages`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accesstoken}`,
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.ok) {
                console.log('Response:', data);
                await addDoc(collection(db, 'whatsapphistory'), {
                    type: 'Checkout',
                    custname: custname,
                    mobile: mobile,
                    createdAt: Timestamp.now(),
                });
                window.location.href = "/checkout-history"

            } else {
                alert(`❌ Error: ${data.error.message}`);
                console.error('API Error:', data);
                window.location.href = "/checkout-history"

            }
        } catch (error) {
            console.error('Fetch Error:', error);
            alert('❌ Failed to send the message.');
            window.location.href = "/checkout-history"
        }
    };

    const handlePaymodeEdit = (id, pay1, pay2) => {
        setEditingId(id);
        setuppaymode1(pay1);
        setuppaymode2(pay2);
        setPaymodeEditOpen(true);
    };

    const updatePaymode = async () => {
        await updateDoc(doc(db, "payhistory", paymodeid), {
            paymode1: uppaymode1,
            paymode2: uppaymode2,
        });

        fetchData1()
        Toast.fire({ icon: "success", title: 'Payment Mode successfully updated' });
    }


    const handleamount = (e) => {
        setamount(e.target.value);
        setdiscount(0);
        setroomrate(e.target.value);
    }



    const InvoicePDF = () => (
        <Document>
            <Page size="A4" style={styles.page}>


                <View style={styles.columnContainer1}>
                    <View style={styles.column1}>
                        <View style={styles.section1}>
                            <Text style={styles.header}>Dasara Executive</Text>
                            <Text style={styles.subHeader}>GSTIN No - 27AAGCD7108K1ZH</Text>
                            <Text style={styles.subHeader}>Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601</Text>
                            <Text style={styles.subHeader}>Phone: +91 9975294940 | Email: dasaraexecutive@gmail.com</Text>
                            <Text style={styles.subHeader}>Website: www.dasaraexecutive.com</Text>
                        </View>
                    </View>
                    <View >
                        <View style={styles.section1}>
                            <Text style={styles.header}>TAX INVOICE</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.columnContainer1}>
                    <View style={styles.column}>
                        <View style={styles.section1}>
                            <View style={styles.row}>
                                <Text style={styles.label}>Name:</Text>
                                <Text style={styles.value}>{bookingData.customers.custname}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Address:</Text>
                                <Text style={styles.value}>{bookingData.customers.address} , {bookingData.customers.city},   {bookingData.customers.state} </Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Phone:</Text>
                                <Text style={styles.value}>{bookingData.customers.mobile}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Email:</Text>
                                <Text style={styles.value1}>{bookingData.customers.email}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>GST Name:</Text>
                                <Text style={styles.value}>{bookingData.customers.gstname}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>GST No:</Text>
                                <Text style={styles.value}>{bookingData.customers.gstno}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.column}>
                        <View style={styles.section1}>
                            <View style={styles.row}>
                                <Text style={styles.label}>Invoice No:</Text>
                                <Text style={styles.value}>{bookingData.invoiceno}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Invoice Date:</Text>
                                <Text style={styles.value}>{moment().format('DD/MM/YYYY HH:mm A')}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>No Of Rooms:</Text>
                                <Text style={styles.value}> {bookingData.noofrooms} Rooms</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>No of Days:</Text>
                                <Text style={styles.value}>{bookingData.noofdays} Days</Text>
                            </View>

                            <View style={styles.row}>
                                <Text style={styles.label}>Check-In Date:</Text>
                                <Text style={styles.value}>{moment(bookingData.checkindate).format('DD/MM/YYYY')}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>Check-Out Date:</Text>
                                <Text style={styles.value}>{moment(bookingData.checkoutdate).format('DD/MM/YYYY')}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>No Of Persons:</Text>
                                <Text style={styles.value}> {bookingData.adults} (A) / {bookingData.childs} (C)</Text>
                            </View>
                        </View>
                    </View>

                </View>

                <View style={styles.section2}>
                    <View style={styles.tableHeader}>
                        <Text style={{ width: '15%' }}>Room Type</Text>
                        <Text style={{ width: '10%' }}>Room No</Text>
                        <Text style={{ width: '15%' }}>Plan Name</Text>
                        <Text style={{ width: '10%', textAlign: 'right' }}>Rate</Text>
                        <Text style={{ width: '10%', textAlign: 'right' }}>No Of Day</Text>
                        <Text style={{ width: '15%', textAlign: 'right' }}>Room Amount</Text>
                        <Text style={{ width: '10%', textAlign: 'right' }}>Discount</Text>
                        <Text style={{ width: '15%', textAlign: 'right' }}>Total (Inc Tax)</Text>
                    </View>
                    {bookingData.rooms.map((item, index) => {
                        let diaamount = (parseFloat(item.amount) - parseFloat(item.roomrate)) * parseFloat(bookingData.noofdays);
                        let amount = parseFloat(item.amount);
                        let roomrate = parseFloat(item.roomrate) * parseFloat(bookingData.noofdays);
                        let totall = parseFloat(item.amount) * parseFloat(bookingData.noofdays);
                        return (
                            <View style={styles.tableRow} key={index}>
                                <Text style={{ width: '15%' }}>{item.roomtypename}</Text>
                                <Text style={{ width: '10%' }}>{item.roomno} {item.status === 'Exchanged' && " (Exchanged)"}</Text>
                                <Text style={{ width: '15%' }}>{item.planname}</Text>
                                <Text style={{ width: '10%', textAlign: 'right' }}>{amount.toFixed(2)}</Text>
                                <Text style={{ width: '10%', textAlign: 'right' }}>{bookingData.noofdays} Day</Text>
                                <Text style={{ width: '15%', textAlign: 'right' }}>{totall.toFixed(2)}</Text>
                                <Text style={{ width: '10%', textAlign: 'right' }}>{diaamount.toFixed(2)} ({parseFloat(item.discount)}%)</Text>
                                <Text style={{ width: '15%', textAlign: 'right' }}>{roomrate.toFixed(2)}</Text>
                            </View>
                        );
                    })}
                </View>

                <View style={styles.tableContainer}>
                    {/* Left Side - Bank Details */}
                    <View style={styles.leftColumn}>
                        <Text style={styles.header1}>BANK DETAILS</Text>
                        <Text style={styles.label1}>Bank Name: Bank Of Maharashtra</Text>
                        <Text style={styles.label1}>Account No: 60442386856</Text>
                        <Text style={styles.label1}>IFSC Code: MAHB0000743</Text>
                        <Text style={styles.label1}>Account Name: Dasara Infraprojects</Text>
                        <Text style={styles.label1}>Branch: TULJAPUR</Text>
                    </View>

                    {/* Right Side - Payment Summary */}
                    <View style={styles.rightColumn}>
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Subtotal</Text>
                            <Text style={styles.value}>{subtotal}</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Total CGST (2.5%)</Text>
                            <Text style={styles.value}>{cgst}</Text>
                        </View>
                        {bookingData.customers.state === 'Maharashtra' ? (
                            <>
                                <View style={styles.tableRow}>
                                    <Text style={styles.label}>Total SGST (2.5%)</Text>
                                    <Text style={styles.value}>{cgst}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.label}>Total IGST</Text>
                                    <Text style={styles.value}>0.00</Text>
                                </View>
                            </>
                        ) : (
                            <>
                                <View style={styles.tableRow}>
                                    <Text style={styles.label}>Total SGST (0%)</Text>
                                    <Text style={styles.value}>0.00</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.label}>Total IGST (2.5%)</Text>
                                    <Text style={styles.value}>{cgst}</Text>
                                </View>
                            </>
                        )}
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Room Amount</Text>
                            <Text style={styles.value}>{roomtotal}</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Extra Service</Text>
                            <Text style={styles.value}>{servicetotal}</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Grand Total</Text>
                            <Text style={styles.value}>{parseFloat(bookingData.totalamount).toFixed(2)}</Text>
                        </View>
                        {/* <View style={styles.tableRow}>
                            <Text style={styles.label}>Paid</Text>
                            <Text style={styles.value}>{parseFloat(bookingData.advance).toFixed(2)}</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={styles.label}>Balance</Text>
                            <Text style={styles.value}>{parseFloat(bookingData.remaining).toFixed(2)}</Text>
                        </View> */}
                    </View>
                </View>
                <Text style={styles.footer}>Total in Words: {amountInWords} Rupees Only</Text>
                <Text style={styles.footer1}>Thank you for choosing Dasara Executive!</Text>
            </Page>
        </Document>
    );



    const ProfileItem = ({ label, value }) => (
        <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
                {label}
            </Typography>
            <Typography variant="body2" fontWeight={600} textAlign="right">
                {value || "-"}
            </Typography>
        </Stack>
    );

    const ImageCard = ({ title, url }) => {
        if (!url) return null;

        return (
            <Card sx={{ borderRadius: 1, mb: 2 }}>
                <CardContent>
                    <Typography variant="subtitle2" fontWeight={600} mb={1}>
                        {title}
                    </Typography>
                    <Box
                        component="img"
                        src={url}
                        alt={title}
                        sx={{
                            width: "100%",
                            borderRadius: 2,
                            boxShadow: 2
                        }}
                    />
                </CardContent>
            </Card>
        );
    };

    const InfoRow = ({ label, value }) => (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" color="text.secondary">
                {label}
            </Typography>
            <Typography variant="body2" fontWeight={600}>
                {value || "-"}
            </Typography>
        </Stack>
    );

    const AmountRow = ({ label, value, color, bold }) => (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography
                variant="body2"
                color="text.secondary"
            >
                {label}
            </Typography>

            <Typography
                variant="body2"
                fontWeight={bold ? 700 : 600}
                color={color || "text.primary"}
            >
                ₹ {value || "0.00"}
            </Typography>
        </Stack>
    );

    return (
        <div>

            {isLoading && (
                <div style={overlayStyle}>
                    <ClipLoader color="#36d7b7" size={60} />
                </div>
            )}
            <Menu />

            {
                bookingData.customerId &&
                <Card className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <Grid className="col-md-9 mt-3">
                                    <div className='row'>
                                        <div className='col-sm-6'>
                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>
                                                    <Typography variant="h6" fontWeight={700} mb={2}>
                                                        Stay Details
                                                    </Typography>

                                                    <Stack spacing={1.2}>
                                                        <InfoRow
                                                            label="Entry Timing"
                                                            value={entryTiming}
                                                        />

                                                        <InfoRow
                                                            label="Check-in"
                                                            value={`${moment(bookingData.checkindate).format("DD/MM/YYYY")} ${bookingData.checkintime}`}
                                                        />

                                                        <InfoRow
                                                            label="Check-out"
                                                            value={`${moment(bookingData.checkoutdate).format("DD/MM/YYYY")} ${bookingData.checkouttime}`}
                                                        />

                                                        <Divider />

                                                        <InfoRow
                                                            label="No. of Days"
                                                            value={`${bookingData.noofdays} Day(s)`}
                                                        />

                                                        <InfoRow
                                                            label="Adults"
                                                            value={`${bookingData.adults} Adult(s)`}
                                                        />

                                                        <InfoRow
                                                            label="Children"
                                                            value={`${bookingData.childs} Child(ren)`}
                                                        />

                                                        <InfoRow
                                                            label="Rooms"
                                                            value={`${bookingData.noofrooms} Room(s)`}
                                                        />
                                                    </Stack>
                                                </CardContent>
                                            </Card>
                                        </div>
                                        <div className='col-sm-6'>
                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>
                                                    <Typography variant="h6" fontWeight={700} mb={2}>
                                                        Billing Summary
                                                    </Typography>

                                                    <Stack spacing={1.2}>
                                                        <AmountRow
                                                            label="Room Amount"
                                                            value={bookingData.rooamount}
                                                        />

                                                        <AmountRow
                                                            label="Extra Services"
                                                            value={bookingData.serviceamount}
                                                        />

                                                        <AmountRow
                                                            label="Restaurant Amount"
                                                            value={bookingData.restoamount}
                                                        />

                                                        <AmountRow
                                                            label="Round Off"
                                                            value={bookingData.roundoff}
                                                        />

                                                        <Divider />

                                                        <AmountRow
                                                            label="Total Amount"
                                                            value={bookingData.totalamount}
                                                            bold
                                                        />

                                                        <AmountRow
                                                            label="Paid"
                                                            value={bookingData.advance}
                                                            color="success.main"
                                                        />

                                                        <AmountRow
                                                            label="Remaining"
                                                            value={bookingData.remaining}
                                                            color="error.main"
                                                            bold
                                                        />
                                                    </Stack>
                                                </CardContent>
                                            </Card>

                                        </div>

                                        <div className='container'>
                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>

                                                    {/* HEADER */}
                                                    <Stack
                                                        direction="row"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                        mb={2}
                                                    >
                                                        <Typography variant="h6" fontWeight={700} textTransform="uppercase">
                                                            Room Details
                                                        </Typography>

                                                        {bookingData.status === "Booked" && (
                                                            <Stack direction="row" spacing={1}>
                                                                <Button
                                                                    size="small"
                                                                    variant="contained"
                                                                    onClick={() => {
                                                                        emptyRooms();          // your current handler
                                                                        setRoomModalOpen(true); // open MUI dialog
                                                                    }}
                                                                >
                                                                    Add Rooms
                                                                </Button>


                                                                <Button
                                                                    size="small"
                                                                    variant="outlined"
                                                                    color="secondary"
                                                                    onClick={() => {
                                                                        emptyRooms();            // your existing handler
                                                                        setExtendModalOpen(true); // open MUI dialog
                                                                    }}
                                                                >
                                                                    Extend Rooms
                                                                </Button>

                                                                <Button
                                                                    size="small"
                                                                    variant="outlined"
                                                                    color="error"
                                                                    onClick={() => {
                                                                        emptyRooms();             // your existing handler
                                                                        setReduceModalOpen(true); // open MUI dialog
                                                                    }}
                                                                >
                                                                    Reduce Rooms
                                                                </Button>

                                                            </Stack>
                                                        )}
                                                    </Stack>

                                                    {/* TABLE */}
                                                    <TableContainer component={Paper} elevation={0}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Room Type</TableCell>
                                                                    <TableCell>Room No</TableCell>
                                                                    <TableCell>Plan</TableCell>
                                                                    <TableCell>Amount</TableCell>
                                                                    <TableCell>Discount</TableCell>
                                                                    <TableCell>Room Rate</TableCell>
                                                                    {/* <TableCell>User</TableCell> */}
                                                                    <TableCell align="center">Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                {bookingData.rooms.map((item, index) => (
                                                                    <TableRow key={index} hover>
                                                                        <TableCell>{item.roomtypename}</TableCell>

                                                                        <TableCell>
                                                                            {item.roomno}
                                                                            {item.status === "Exchanged" && (
                                                                                <Chip
                                                                                    label="Exchanged"
                                                                                    size="small"
                                                                                    color="warning"
                                                                                    sx={{ ml: 1 }}
                                                                                />
                                                                            )}
                                                                        </TableCell>

                                                                        <TableCell>{item.planname}</TableCell>

                                                                        <TableCell>₹ {item.amount}</TableCell>

                                                                        <TableCell>{item.discount} %</TableCell>

                                                                        <TableCell>₹ {item.roomrate}</TableCell>

                                                                        {/* <TableCell>{item.username}</TableCell> */}

                                                                        <TableCell align="center">
                                                                            {bookingData.approval1 === "Yes" && (
                                                                                <IconButton
                                                                                    color="primary"
                                                                                    onClick={() => {
                                                                                        emptyRooms2(item);           // your existing handler
                                                                                        setExchangeItem(item);       // pass current item
                                                                                        setExchangeModalOpen(true);  // open dialog
                                                                                    }}
                                                                                >
                                                                                    <SwapHoriz />
                                                                                </IconButton>

                                                                            )}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}

                                                                {!bookingData.rooms.length && (
                                                                    <TableRow>
                                                                        <TableCell colSpan={8} align="center">
                                                                            No rooms added
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>

                                                </CardContent>
                                            </Card>

                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>

                                                    {/* HEADER */}
                                                    <Stack
                                                        direction="row"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                        mb={2}
                                                    >
                                                        <Typography variant="h6" fontWeight={700} textTransform="uppercase">
                                                            Extra Services
                                                        </Typography>

                                                        {bookingData.status === "Booked" && (
                                                            <Button
                                                                size="small"
                                                                variant="contained"
                                                                color="success"
                                                                onClick={() => setServiceModalOpen(true)}
                                                            >
                                                                Add Extra Service
                                                            </Button>
                                                        )}

                                                    </Stack>

                                                    {/* TABLE */}
                                                    <TableContainer component={Paper} elevation={0}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Service Name</TableCell>
                                                                    <TableCell>Room No</TableCell>
                                                                    <TableCell>Amount</TableCell>
                                                                    <TableCell>Qty</TableCell>
                                                                    <TableCell>Discount</TableCell>
                                                                    <TableCell>Service Amount</TableCell>
                                                                    {/* <TableCell>User</TableCell> */}
                                                                    <TableCell align="center">Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                {bookingServices.map((item, index) => (
                                                                    <TableRow key={index} hover>
                                                                        <TableCell>{item.servicename}</TableCell>
                                                                        <TableCell>{item.roomno}</TableCell>
                                                                        <TableCell>₹ {item.servamount}</TableCell>
                                                                        <TableCell>{item.quantity}</TableCell>
                                                                        <TableCell>{item.discount} %</TableCell>
                                                                        <TableCell>₹ {item.servicerate}</TableCell>
                                                                        {/* <TableCell>{item.username}</TableCell> */}

                                                                        <TableCell align="center">
                                                                            {bookingData.approval3 === "Yes" && (
                                                                                <IconButton
                                                                                    color="error"
                                                                                    onClick={() => cancleExtraService(item)}
                                                                                >
                                                                                    <Close />
                                                                                </IconButton>
                                                                            )}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}

                                                                {!bookingData.services.length && (
                                                                    <TableRow>
                                                                        <TableCell colSpan={8} align="center">
                                                                            No extra services added
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>

                                                </CardContent>
                                            </Card>

                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>

                                                    {/* HEADER */}
                                                    <Stack
                                                        direction="row"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                        mb={2}
                                                    >
                                                        <Typography variant="h6" fontWeight={700} textTransform="uppercase">
                                                            Payment History
                                                        </Typography>

                                                        <Stack direction="row" spacing={1}>
                                                            {bookingData.remaining > 0 && (
                                                                <Button
                                                                    size="small"
                                                                    variant="contained"
                                                                    color="warning"
                                                                    onClick={() => {
                                                                        emptyRooms1();          // your existing handler
                                                                        setPayModalOpen(true);  // open MUI dialog
                                                                    }}
                                                                >
                                                                    Add Payment
                                                                </Button>

                                                            )}

                                                            {bookingData.remaining < 0 && (
                                                                <Button
                                                                    size="small"
                                                                    variant="contained"
                                                                    color="error"
                                                                    onClick={() => {
                                                                        emptyRooms1();               // your existing handler
                                                                        setReturnPaymentOpen(true);  // open dialog
                                                                    }}
                                                                >
                                                                    Return Payment
                                                                </Button>

                                                            )}
                                                        </Stack>
                                                    </Stack>

                                                    {/* TABLE */}
                                                    <TableContainer component={Paper} elevation={0}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Paymode 1</TableCell>
                                                                    <TableCell>Amount 1</TableCell>
                                                                    <TableCell>Paytime 1</TableCell>
                                                                    <TableCell>Paymode 2</TableCell>
                                                                    <TableCell>Amount 2</TableCell>
                                                                    <TableCell>Paytime 2</TableCell>
                                                                    <TableCell>Date & Time</TableCell>
                                                                    <TableCell>Note</TableCell>
                                                                    {/* <TableCell>User</TableCell> */}
                                                                    <TableCell align="center">Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                {payhistory.map((item, index) => (
                                                                    <TableRow key={index} hover>
                                                                        <TableCell>{item.paymode1}</TableCell>
                                                                        <TableCell>₹ {item.amount1}</TableCell>
                                                                        <TableCell>{item.paytime1}</TableCell>
                                                                        <TableCell>{item.paymode2}</TableCell>
                                                                        <TableCell>₹ {item.amount2}</TableCell>
                                                                        <TableCell>{item.paytime2}</TableCell>
                                                                        <TableCell>{item.createdat}</TableCell>
                                                                        <TableCell>{item.note}</TableCell>
                                                                        {/* <TableCell>{item.username}</TableCell> */}

                                                                        <TableCell align="center">
                                                                            <IconButton
                                                                                color="success"
                                                                                onClick={() => handlePaymodeEdit(item.id, item.paymode1, item.paymode2)}
                                                                            >
                                                                                <Edit />
                                                                            </IconButton>

                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}

                                                                {!payhistory.length && (
                                                                    <TableRow>
                                                                        <TableCell colSpan={10} align="center">
                                                                            No payment history found
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>

                                                </CardContent>
                                            </Card>
                                            <Card sx={{ borderRadius: 1 }}>
                                                <CardContent>

                                                    <Typography
                                                        variant="h6"
                                                        fontWeight={700}
                                                        textTransform="uppercase"
                                                        mb={2}
                                                    >
                                                        Check-In Details (Date-wise)
                                                    </Typography>

                                                    <TableContainer component={Paper} elevation={0}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Check-In</TableCell>
                                                                    <TableCell>Check-Out</TableCell>
                                                                    <TableCell>Room Type</TableCell>
                                                                    <TableCell>Room No</TableCell>
                                                                    <TableCell>Plan</TableCell>
                                                                    {/* <TableCell>User</TableCell> */}
                                                                    <TableCell align="center">Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                {checkindetails.map((item, index) => (
                                                                    <TableRow key={index} hover>
                                                                        <TableCell>
                                                                            {moment(item.checkindate).format("DD/MM/YYYY")}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {moment(item.checkoutdate).format("DD/MM/YYYY")}
                                                                        </TableCell>
                                                                        <TableCell>{item.roomtype}</TableCell>
                                                                        <TableCell>{item.roomno}</TableCell>
                                                                        <TableCell>{item.planname}</TableCell>
                                                                        {/* <TableCell>{item.username}</TableCell> */}

                                                                        <TableCell align="center">
                                                                            <IconButton
                                                                                color="error"
                                                                                onClick={() => deletCheckin(item.id)}
                                                                            >
                                                                                <Close />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}

                                                                {!checkindetails.length && (
                                                                    <TableRow>
                                                                        <TableCell colSpan={7} align="center">
                                                                            No check-in details found
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>

                                                </CardContent>
                                            </Card>
                                        </div>


                                    </div>
                                </Grid>

                                <Grid className="col-md-3 mt-3">
                                    <Card sx={{ borderRadius: 1, mb: 2 }}>
                                        <CardContent>
                                            <Stack alignItems="center" spacing={1}>
                                                <Avatar
                                                    sx={{ width: 70, height: 70, bgcolor: "primary.main" }}
                                                >
                                                    {bookingData?.customers?.custname?.[0]}
                                                </Avatar>

                                                <Typography variant="h6" fontWeight={700} textTransform="capitalize">
                                                    {bookingData.customers.custname}
                                                </Typography>

                                                <Typography variant="body2" color="text.secondary">
                                                    {bookingData.customers.mobile}
                                                </Typography>

                                                <Button
                                                    size="small"
                                                    startIcon={<Edit />}
                                                    onClick={() => {
                                                        getCustData();
                                                        setCustModalOpen(true);
                                                    }}
                                                >
                                                    Edit Details
                                                </Button>

                                            </Stack>

                                            <Divider sx={{ my: 2 }} />

                                            <Stack spacing={1}>
                                                <ProfileItem label="Email" value={bookingData.customers.email} />
                                                <ProfileItem
                                                    label="Address"
                                                    value={`${bookingData.customers.city}, ${bookingData.customers.address}, ${bookingData.customers.state}`}
                                                />
                                                <ProfileItem label="Gender" value={bookingData.customers.gender} />
                                                <ProfileItem label="GST Name" value={bookingData.customers.gstname} />
                                                <ProfileItem label="GST No" value={bookingData.customers.gstno} />
                                                <ProfileItem label="Document Type" value={bookingData.customers.documenttype} />
                                                <ProfileItem label="ID No" value={bookingData.customers.idno} />
                                                <ProfileItem label="Visit Purpose" value={bookingData.visitpurpose} />
                                                <ProfileItem label="Booking Source" value={bookingData.bookingsource} />
                                                <ProfileItem label="Note" value={bookingData.note} />
                                            </Stack>

                                            {bookingData.status === "Booked" && (
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    sx={{ mt: 3 }}
                                                    onClick={() => {
                                                        emptyRooms1();           // your existing handler
                                                        setCheckoutOpen(true);   // open dialog
                                                    }}
                                                >
                                                    Check Out
                                                </Button>

                                            )}
                                        </CardContent>
                                    </Card>

                                    {/* IMAGE CARDS */}
                                    <ImageCard title="Visitor Photo" url={bookingData.visitorPhotoUrl} />
                                    <ImageCard title="ID Proof Front" url={bookingData.idFrontUrl} />
                                    <ImageCard title="ID Proof Back" url={bookingData.idBackUrl} />
                                    <ImageCard title="Couple Photo" url={bookingData.couplePhotoUrl} />
                                </Grid>
                            </div>
                        </div>
                    </section>

                    <Dialog
                        open={serviceModalOpen}
                        onClose={() => setServiceModalOpen(false)}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>
                            Add Extra Service
                        </DialogTitle>

                        <DialogContent dividers>

                            {/* SERVICE ENTRY TABLE */}
                            <TableContainer component={Paper} sx={{ mb: 2 }}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Service</TableCell>
                                            <TableCell>Room</TableCell>
                                            <TableCell>Amount</TableCell>
                                            <TableCell>Qty</TableCell>
                                            <TableCell>Discount</TableCell>
                                            <TableCell>Total</TableCell>
                                            <TableCell align="center">Action</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    size="small"
                                                    fullWidth
                                                    value={serviceid}
                                                    onChange={handleServiceid}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    {extraservices.map((item) => (
                                                        <MenuItem key={item.id} value={item.id}>
                                                            {item.servicename}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </TableCell>

                                            <TableCell>
                                                <Select
                                                    size="small"
                                                    fullWidth
                                                    value={roomid}
                                                    onChange={(e) => setroomid(e.target.value)}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    {bookingData.rooms.map((item) => (
                                                        <MenuItem key={item.roomid} value={item.roomid}>
                                                            {item.roomno}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </TableCell>

                                            <TableCell>
                                                <TextField
                                                    size="small"
                                                    value={servamount}
                                                    onChange={hanldeServeAmount}
                                                />
                                            </TableCell>

                                            <TableCell>
                                                <TextField
                                                    size="small"
                                                    value={quantity}
                                                    onChange={handleQuantity}
                                                />
                                            </TableCell>

                                            <TableCell>
                                                <TextField
                                                    size="small"
                                                    value={discount}
                                                    onChange={handleDiscount}
                                                />
                                            </TableCell>

                                            <TableCell>
                                                <TextField
                                                    size="small"
                                                    value={servicerate}
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </TableCell>

                                            <TableCell align="center">
                                                <IconButton color="primary" onClick={handleServiceArray}>
                                                    <Add />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>

                                        {services.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.servicename}</TableCell>
                                                <TableCell>{item.roomno}</TableCell>
                                                <TableCell>{item.servamount}</TableCell>
                                                <TableCell>{item.quantity}</TableCell>
                                                <TableCell>{item.discount}</TableCell>
                                                <TableCell>{item.servicerate}</TableCell>
                                                <TableCell align="center">
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => removeItem(item)}
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* PAYMENT DETAILS */}
                            <Grid className="row" spacing={2}>
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 1</InputLabel>
                                        <Select
                                            value={paymode1}
                                            label="Pay Mode 1"
                                            onChange={(e) => setpaymode1(e.target.value)}
                                        >
                                            {paymodes.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.paymode}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Amount 1"
                                        value={amount1}
                                        onChange={handleamount1}
                                    />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Payment Note 1"
                                        value={paytime1}
                                        onChange={(e) => setpaytime1(e.target.value)}
                                    />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 2</InputLabel>
                                        <Select
                                            value={paymode2}
                                            label="Pay Mode 2"
                                            onChange={(e) => setpaymode2(e.target.value)}
                                        >
                                            {paymodes.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.paymode}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Amount 2"
                                        value={amount2}
                                        onChange={handleamount2}
                                    />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Payment Note 2"
                                        value={paytime2}
                                        onChange={(e) => setpaytime2(e.target.value)}
                                    />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Total Amount"
                                        value={serviceamount}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Paid"
                                        value={advance}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Remaining"
                                        value={remaining}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Note"
                                        value={note}
                                        onChange={(e) => setnote(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={storeService}
                                disabled={isLoading}
                            >
                                {isLoading ? "Submitting..." : "Submit"}
                            </Button>
                            <Button onClick={() => setServiceModalOpen(false)}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={custModalOpen}
                        onClose={() => setCustModalOpen(false)}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>Update Customer Details</DialogTitle>

                        <DialogContent dividers>
                            <Grid className="row" spacing={2} mt={1}>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Customer Name" value={custname} onChange={(e) => setcustname(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Mobile" value={mobile} onChange={handlemobile} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Email" value={email} onChange={(e) => setemail(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Address" value={address} onChange={(e) => setaddress(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="City" value={city} onChange={(e) => setcity(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="State" value={state} onChange={(e) => setstate(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Gender</InputLabel>
                                        <Select value={gender} onChange={(e) => setgender(e.target.value)}>
                                            <MenuItem value="Male">Male</MenuItem>
                                            <MenuItem value="Female">Female</MenuItem>
                                            <MenuItem value="Other">Other</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Visit Purpose</InputLabel>
                                        <Select value={visitpurpose} onChange={(e) => setvisitpurpose(e.target.value)}>
                                            <MenuItem value="Darshan">Darshan</MenuItem>
                                            <MenuItem value="Tourist">Tourist</MenuItem>
                                            <MenuItem value="Business">Business</MenuItem>
                                            <MenuItem value="Official">Official</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="GST Name" value={gstname} onChange={(e) => setgstname(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="GST No" value={gstno} onChange={(e) => setgstno(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Booking Source</InputLabel>
                                        <Select value={bookingsource} onChange={(e) => setbookingsource(e.target.value)}>
                                            <MenuItem value="Walking">Walking</MenuItem>
                                            <MenuItem value="Website">Website</MenuItem>
                                            <MenuItem value="OTA">OTA</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Document Type" value={documenttype} onChange={(e) => setdocumenttype(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="ID No" value={idno} onChange={(e) => setidno(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Adults" value={adults} onChange={(e) => setadults(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Childs" value={childs} onChange={(e) => setchilds(e.target.value)} />
                                </Grid>

                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => setCustModalOpen(false)}>Cancel</Button>
                            <Button variant="contained" color="success" onClick={updateCust}>
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Dialog
                        open={roomModalOpen}
                        onClose={() => setRoomModalOpen(false)}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>Add New Rooms</DialogTitle>

                        <DialogContent dividers>

                            {/* ROOM TABLE */}
                            <TableContainer component={Paper} variant="outlined">
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Room Type</TableCell>
                                            <TableCell>Room No</TableCell>
                                            <TableCell>Plan Name</TableCell>
                                            <TableCell>Amount</TableCell>
                                            <TableCell>Discount</TableCell>
                                            <TableCell>Discount Rate</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/* Input Row */}
                                        <TableRow>
                                            <TableCell>
                                                <Select fullWidth size="small" value={rtypeid} onChange={(e) => handleroomtypeChange(e.target.value)}>
                                                    <MenuItem value="">Select</MenuItem>
                                                    {roomtypes.map((item) => (
                                                        <MenuItem key={item.id} value={item.id}>{item.roomTypeName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </TableCell>
                                            <TableCell>
                                                <Select fullWidth size="small" value={roomid} onChange={(e) => setroomid(e.target.value)}>
                                                    <MenuItem value="">Select</MenuItem>
                                                    {rooms.map((item) => (
                                                        <MenuItem key={item.id} value={item.id}>{item.data.roomNo}</MenuItem>
                                                    ))}
                                                </Select>
                                            </TableCell>
                                            <TableCell>
                                                <Select fullWidth size="small" value={planid} onChange={(e) => handleplanChange1(e.target.value)}>
                                                    <MenuItem value="">Select</MenuItem>
                                                    {plans.map((item) => (
                                                        <MenuItem key={item.id} value={item.id}>{item.data.planName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </TableCell>
                                            <TableCell>
                                                <TextField size="small" value={amount} InputProps={{ readOnly: true }} fullWidth />
                                            </TableCell>
                                            <TableCell>
                                                <TextField size="small" value={discount} onChange={(e) => caltotal1(e.target.value)} fullWidth />
                                            </TableCell>
                                            <TableCell>
                                                <TextField size="small" value={roomrate} InputProps={{ readOnly: true }} fullWidth />
                                            </TableCell>
                                            <TableCell>
                                                <IconButton color="primary" onClick={handleRoomArray}>
                                                    <AddIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>

                                        {/* Existing Booking Rooms */}
                                        {bookingrooms.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.roomtypename}</TableCell>
                                                <TableCell>{item.roomno}</TableCell>
                                                <TableCell>{item.planname}</TableCell>
                                                <TableCell>{item.amount}</TableCell>
                                                <TableCell>{item.discount}</TableCell>
                                                <TableCell>{item.roomrate}</TableCell>
                                                <TableCell>
                                                    <IconButton color="error" onClick={() => removeItem1(item)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* Payment Section */}
                            <Grid className="row" spacing={2} mt={2}>
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 1</InputLabel>
                                        <Select value={paymode1} onChange={(e) => setpaymode1(e.target.value)}>
                                            <MenuItem value="" />
                                            {paymodes.map((p) => (
                                                <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Amount 1" value={amount1} onChange={handleamount3} />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Payment 1 Note" value={paytime1} onChange={(e) => setpaytime1(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 2</InputLabel>
                                        <Select value={paymode2} onChange={(e) => setpaymode2(e.target.value)}>
                                            <MenuItem value="" />
                                            {paymodes.map((p) => (
                                                <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Amount 2" value={amount2} onChange={handleamount4} />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Payment 2 Note" value={paytime2} onChange={(e) => setpaytime2(e.target.value)} />
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Total Amount" value={rooamount} InputProps={{ readOnly: true }} />
                                    <Typography variant="caption">
                                        Room Amount for {bookingData.noofdays} Days
                                    </Typography>
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Paid Amount" value={advance} InputProps={{ readOnly: true }} />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField fullWidth size="small" label="Remaining" value={remaining} InputProps={{ readOnly: true }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField fullWidth size="small" label="Note" value={note} onChange={(e) => setnote(e.target.value)} />
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => setRoomModalOpen(false)}>Cancel</Button>
                            <Button variant="contained" color="success" onClick={storeRoom}>Submit</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={payModalOpen}
                        onClose={() => setPayModalOpen(false)}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>Add Payment</DialogTitle>

                        <DialogContent dividers>
                            <Grid className="row" spacing={2}>
                                {/* Payment Mode 1 */}
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 1</InputLabel>
                                        <Select value={paymode1} onChange={(e) => setpaymode1(e.target.value)}>
                                            <MenuItem value="" />
                                            {paymodes.map((p) => (
                                                <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Amount 1"
                                        type="number"
                                        value={amount1}
                                        onChange={handleamount5}
                                    />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Payment 1 Note"
                                        value={paytime1}
                                        onChange={(e) => setpaytime1(e.target.value)}
                                    />
                                </Grid>

                                {/* Payment Mode 2 */}
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 2</InputLabel>
                                        <Select value={paymode2} onChange={(e) => setpaymode2(e.target.value)}>
                                            <MenuItem value="" />
                                            {paymodes.map((p) => (
                                                <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Amount 2"
                                        type="number"
                                        value={amount2}
                                        onChange={handleamount6}
                                    />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Payment 2 Note"
                                        value={paytime2}
                                        onChange={(e) => setpaytime2(e.target.value)}
                                    />
                                </Grid>

                                {/* Totals */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Total Amount"
                                        value={totalamount}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Paid Amount"
                                        value={advance}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Remaining"
                                        value={remaining}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                {/* Note */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Note"
                                        value={note}
                                        onChange={(e) => setnote(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => setPayModalOpen(false)}>Close</Button>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={storePayment}
                                disabled={isLoading}
                            >
                                {isLoading ? "Submitting..." : "Submit"}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={extendModalOpen}
                        onClose={() => setExtendModalOpen(false)}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>Extend Rooms</DialogTitle>

                        <DialogContent dividers>
                            <Grid className="row" spacing={2}>
                                {/* Extend Room Input */}
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel htmlFor="extend-room">Extend Room For</InputLabel>
                                        <OutlinedInput
                                            id="extend-room"
                                            value={extendRoom}
                                            onChange={handleExtendRoom}
                                            endAdornment={<InputAdornment position="end">Days</InputAdornment>}
                                            label="Extend Room For"
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Payment Mode 1 */}
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 1</InputLabel>
                                        <Select
                                            value={paymode1}
                                            onChange={(e) => setpaymode1(e.target.value)}
                                        >
                                            <MenuItem value="" />
                                            {paymodes.map((p) => (
                                                <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Amount 1"
                                        type="number"
                                        value={amount1}
                                        onChange={handleamount5}
                                    />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Payment 1 Note"
                                        value={paytime1}
                                        onChange={(e) => setpaytime1(e.target.value)}
                                    />
                                </Grid>

                                {/* Payment Mode 2 */}
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 2</InputLabel>
                                        <Select
                                            value={paymode2}
                                            onChange={(e) => setpaymode2(e.target.value)}
                                        >
                                            <MenuItem value="" />
                                            {paymodes.map((p) => (
                                                <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Amount 2"
                                        type="number"
                                        value={amount2}
                                        onChange={handleamount6}
                                    />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Payment 2 Note"
                                        value={paytime2}
                                        onChange={(e) => setpaytime2(e.target.value)}
                                    />
                                </Grid>

                                {/* Totals */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Total Amount"
                                        value={totalamount}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Paid Amount"
                                        value={advance}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Remaining"
                                        value={remaining}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                {/* Note */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Note"
                                        value={note}
                                        onChange={(e) => setnote(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => setExtendModalOpen(false)}>Close</Button>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={extendRoomStore}
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={reduceModalOpen}
                        onClose={() => setReduceModalOpen(false)}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>Reduce Rooms</DialogTitle>

                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                {/* Reduce Room Input */}
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel htmlFor="reduce-room">Reduce Room For</InputLabel>
                                        <OutlinedInput
                                            id="reduce-room"
                                            value={extendRoom}
                                            onChange={handleReduceRoom}
                                            endAdornment={<InputAdornment position="end">Days</InputAdornment>}
                                            label="Reduce Room For"
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Reduce Amount */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Reduce Amount"
                                        value={totalamount}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => setReduceModalOpen(false)}>Close</Button>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={reduceRoomStore}
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Dialog
                        open={exchangeModalOpen}
                        onClose={() => setExchangeModalOpen(false)}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>Exchange Rooms</DialogTitle>

                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                {/* Old Room Details */}
                                <Grid item xs={12}>
                                    <Typography variant="subtitle1"><b>Old Room</b></Typography>
                                </Grid>
                                {exchangeItem && (
                                    <>
                                        <Grid item xs={2}>
                                            <TextField fullWidth size="small" label="Room Type" value={exchangeItem.roomtypename} InputProps={{ readOnly: true }} />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField fullWidth size="small" label="Room No" value={exchangeItem.roomno} InputProps={{ readOnly: true }} />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField fullWidth size="small" label="Plan Name" value={exchangeItem.planname} InputProps={{ readOnly: true }} />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField fullWidth size="small" label="Amount" value={exchangeItem.amount} InputProps={{ readOnly: true }} />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField fullWidth size="small" label="Discount" value={exchangeItem.discount} InputProps={{ readOnly: true }} />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField fullWidth size="small" label="Rate" value={exchangeItem.roomrate} InputProps={{ readOnly: true }} />
                                        </Grid>
                                    </>
                                )}

                                {/* New Room Selection */}
                                <Grid item xs={2}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Room Type</InputLabel>
                                        <Select value={rtypeid} onChange={(e) => handleroomtypeChange(e.target.value)}>
                                            <MenuItem value="">Select</MenuItem>
                                            {roomtypes.map((item, index) => (
                                                <MenuItem key={index} value={item.id}>{item.roomTypeName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Room No</InputLabel>
                                        <Select value={roomid} onChange={(e) => setroomid(e.target.value)}>
                                            <MenuItem value="">Select</MenuItem>
                                            {rooms.map((item, index) => (
                                                <MenuItem key={index} value={item.id}>{item.data.roomno}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Plan Name</InputLabel>
                                        <Select value={planid} onChange={(e) => handleplanChange(e.target.value)}>
                                            <MenuItem value="OTA">OTA</MenuItem>
                                            {plans.map((item, index) => (
                                                <MenuItem key={index} value={item.id}>{item.data.rateplan}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={2}>
                                    {planid === 'OTA' ? (
                                        <TextField fullWidth size="small" type="number" value={amount} onChange={handleamount} label="Amount" />
                                    ) : (
                                        <TextField fullWidth size="small" type="number" value={amount} label="Amount" InputProps={{ readOnly: true }} />
                                    )}
                                </Grid>
                                <Grid item xs={2}>
                                    <TextField fullWidth size="small" value={discount} onChange={(e) => caltotal2(e.target.value)} label="Discount" />
                                </Grid>
                                <Grid item xs={2}>
                                    <TextField fullWidth size="small" value={roomrate} label="Rate" InputProps={{ readOnly: true }} />
                                </Grid>

                                {/* Additional Info */}
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Room Dirty</InputLabel>
                                        <Select value={durtyRoom} onChange={(e) => setdurtyRoom(e.target.value)}>
                                            <MenuItem value="Yes">Yes</MenuItem>
                                            <MenuItem value="No">No</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Exchange Note"
                                        multiline
                                        rows={3}
                                        value={exchangeNote}
                                        onChange={(e) => setexchangeNote(e.target.value)}
                                    />
                                </Grid>

                                {/* Amount Info */}
                                <Grid item xs={12}>
                                    {rooamount < 0 ? (
                                        <Typography variant="h6">Amount Given To Customer: Rs. {rooamount} /-</Typography>
                                    ) : (
                                        <Typography variant="h6">Amount Taken From Customer: Rs. {rooamount} /-</Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => setExchangeModalOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={storeRoomExchange}>Exchange Room</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={returnPaymentOpen}
                        onClose={() => setReturnPaymentOpen(false)}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>Return Payment</DialogTitle>

                        <DialogContent dividers>
                            <Grid className="row" spacing={2}>
                                {/* Pay Mode 1 */}
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 1</InputLabel>
                                        <Select value={paymode1} onChange={(e) => setpaymode1(e.target.value)}>
                                            <MenuItem value="">Select</MenuItem>
                                            {paymodes.map((item, index) => (
                                                <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Amount 1 */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Amount 1"
                                        type="text"
                                        value={amount1}
                                        onChange={handleamountx1}
                                    />
                                </Grid>

                                {/* Payment1 Note */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Payment1 Note"
                                        type="text"
                                        value={paytime1}
                                        onChange={(e) => setpaytime1(e.target.value)}
                                    />
                                </Grid>

                                {/* Pay Mode 2 */}
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 2</InputLabel>
                                        <Select value={paymode2} onChange={(e) => setpaymode2(e.target.value)}>
                                            <MenuItem value="">Select</MenuItem>
                                            {paymodes.map((item, index) => (
                                                <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Amount 2 (ReadOnly) */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Amount 2"
                                        type="text"
                                        value={amount2}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                {/* Payment2 Note */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Payment2 Note"
                                        type="text"
                                        value={paytime2}
                                        onChange={(e) => setpaytime2(e.target.value)}
                                    />
                                </Grid>

                                {/* Total Amount */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Total Amount"
                                        type="text"
                                        value={totalamount}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                {/* Paid Amount */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Paid Amount"
                                        type="text"
                                        value={advance}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                {/* Remaining */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Remaining"
                                        type="text"
                                        value={remaining}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                {/* Note */}
                                <Grid className="col-sm-3 mb-3">
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Note"
                                        type="text"
                                        value={note}
                                        onChange={(e) => setnote(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => setReturnPaymentOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={storePayment1}>Submit</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={checkoutOpen}
                        onClose={() => setCheckoutOpen(false)}
                        maxWidth="lg"
                        fullWidth
                    >
                        <DialogTitle>Checkout Room</DialogTitle>

                        <DialogContent dividers>
                            <Grid className="row" spacing={2}>

                                {/* Any Damages */}
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Any Damages</InputLabel>
                                        <Select
                                            value={anydamage}
                                            onChange={(e) => setanydamage(e.target.value)}
                                        >
                                            <MenuItem value="No">No</MenuItem>
                                            <MenuItem value="Yes">Yes</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {anydamage === "Yes" && (
                                    <>
                                        <Grid className="col-sm-3 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Damage Amount"
                                                type="number"
                                                value={damageamount}
                                                onChange={handleDamageAmount}
                                            />
                                        </Grid>
                                        <Grid className="col-sm-3 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Damage Note"
                                                value={damagenote}
                                                onChange={(e) => setdamagenote(e.target.value)}
                                            />
                                        </Grid>
                                    </>
                                )}

                                {/* Payment Section */}
                                {totalamount > 0 && (
                                    <>
                                        <Grid className="col-sm-3 mb-3">
                                            <FormControl fullWidth size="small">
                                                <InputLabel>Pay Mode 1</InputLabel>
                                                <Select
                                                    value={paymode1}
                                                    onChange={(e) => setpaymode1(e.target.value)}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    {paymodes.map((item, index) => (
                                                        <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid className="col-sm-3 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Amount 1"
                                                type="number"
                                                value={amount1}
                                                onChange={handleamount5}
                                            />
                                        </Grid>

                                        <Grid className="col-sm-3 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Payment1 Note"
                                                type="text"
                                                value={paytime1}
                                                onChange={(e) => setpaytime1(e.target.value)}
                                            />
                                        </Grid>

                                        <Grid className="col-sm-3 mb-3">
                                            <FormControl fullWidth size="small">
                                                <InputLabel>Pay Mode 2</InputLabel>
                                                <Select
                                                    value={paymode2}
                                                    onChange={(e) => setpaymode2(e.target.value)}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    {paymodes.map((item, index) => (
                                                        <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid className="col-sm-3 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Amount 2"
                                                type="number"
                                                value={amount2}
                                                onChange={handleamount6}
                                            />
                                        </Grid>

                                        <Grid className="col-sm-3 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Payment2 Note"
                                                type="text"
                                                value={paytime2}
                                                onChange={(e) => setpaytime2(e.target.value)}
                                            />
                                        </Grid>

                                        {/* Summary Fields */}
                                        <Grid className="col-sm-3 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Payable Amount"
                                                type="text"
                                                value={totalamount}
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>

                                        <Grid className="col-sm-3 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Paid Amount"
                                                type="text"
                                                value={advance}
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>

                                        <Grid className="col-sm-3 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Remaining"
                                                type="text"
                                                value={remaining}
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>

                                        <Grid className="col-sm-3 mb-3">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Note"
                                                type="text"
                                                value={note}
                                                onChange={(e) => setnote(e.target.value)}
                                            />
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => setCheckoutOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={handleCheckout}>
                                Checkout
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <div className="modal fade" id="paymodeEditModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Update Paymode</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className='row'>
                                        <div className='col-sm-4'>
                                            <FormControl className='form-control'>
                                                <InputLabel id="paymode1" style={{ backgroundColor: "white" }}>Pay Mode 1</InputLabel>
                                                <Select labelId='paymode1' size='small' value={uppaymode1} onChange={(e) => setuppaymode1(e.target.value)} label="Age">
                                                    <MenuItem></MenuItem>
                                                    {
                                                        paymodes.map((item, index) =>
                                                            <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>
                                                        )
                                                    }
                                                </Select>
                                            </FormControl><br /><br />
                                        </div>
                                        <div className='col-sm-4'>
                                            <FormControl className='form-control'>
                                                <InputLabel id="paymode2" style={{ backgroundColor: "white" }}>Pay Mode 2</InputLabel>
                                                <Select labelId='paymode2' size='small' value={uppaymode2} onChange={(e) => setuppaymode2(e.target.value)} label="Age">
                                                    <MenuItem></MenuItem>
                                                    {
                                                        paymodes.map((item, index) =>
                                                            <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>
                                                        )
                                                    }
                                                </Select>
                                            </FormControl><br /><br />
                                        </div>

                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" data-dismiss="modal" className="btn btn-success" onClick={updatePaymode}>Update</button>
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div><Dialog
                        open={paymodeEditOpen}
                        onClose={() => setPaymodeEditOpen(false)}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle>Update Paymode</DialogTitle>

                        <DialogContent dividers>
                            <Grid className="row" spacing={2}>
                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 1</InputLabel>
                                        <Select
                                            value={uppaymode1}
                                            onChange={(e) => setuppaymode1(e.target.value)}
                                        >
                                            <MenuItem value="">Select</MenuItem>
                                            {paymodes.map((item, index) => (
                                                <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid className="col-sm-3 mb-3">
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Pay Mode 2</InputLabel>
                                        <Select
                                            value={uppaymode2}
                                            onChange={(e) => setuppaymode2(e.target.value)}
                                        >
                                            <MenuItem value="">Select</MenuItem>
                                            {paymodes.map((item, index) => (
                                                <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => setPaymodeEditOpen(false)}>Close</Button>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={() => {
                                    updatePaymode(editingId, uppaymode1, uppaymode2);
                                    setPaymodeEditOpen(false);
                                }}
                            >
                                Update
                            </Button>
                        </DialogActions>
                    </Dialog>


                </Card>
            }



        </div>

    )
}
const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000, // Ensure the overlay is on top
};

const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontFamily: 'Helvetica',
    },
    section: {
        marginBottom: 10,
        padding: 10,
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    section1: {
        padding: 10,
    },
    section2: {
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    header: {
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    header1: {
        textAlign: 'center',
        fontSize: 15,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    subHeader: {
        textAlign: 'center',
        fontSize: 10,
        marginBottom: 5,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 5,
    },
    label: {
        fontSize: 10,
        fontWeight: 'bold',
    },
    label1: {
        fontSize: 10,
        fontWeight: 'bold',
        marginTop: 10,
        textAlign: "center"
    },
    value1: {
        fontSize: 10,
    },
    value: {
        fontSize: 10,
        textTransform: "capitalize"
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#e4e4e4',
        padding: 5,
        fontSize: 10,
        fontWeight: 'bold',
    },
    tableRow: {
        flexDirection: 'row',
        padding: 5,
        borderBottomWidth: 1,
        borderBottomColor: '#ddd',
        justifyContent: 'space-between',
        fontSize: 10,
    },
    footer: {
        fontSize: 13,
        marginTop: 20,
        textTransform: "capitalize"
    },
    footer1: {
        textAlign: 'center',
        fontSize: 10,
        marginTop: 50,
    },
    columnContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    columnContainer1: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        justifyContent: 'space-between',
        borderBottomColor: '#000',
    },
    column: {
        width: '48%',
    },
    column1: {
        width: '78%',
    },
    tableContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    leftColumn: {
        width: '48%',
        padding: 10,
    },
    rightColumn: {
        width: '48%',
        padding: 10,
    },

});

export default Reservationdetails
